@if (loading()) { <app-progress></app-progress> }

<div class="page-content query-stepthree-page">
  <div class="container-fluid px-0" style="width: 100%; max-width: 100%; margin: 0; padding: 0;">

    @if (tripInfo(); as trip) {

    <!-- ── Basic Details card ──────────────────────────────── -->
    <div class="bg-white border-bottom px-4 py-3">
      <div class="fw-bold fs-5 mb-1">Basic Details</div>
      <div class="text-muted small mb-3">
        Please review basic details for this quote. You can edit these details
        to provide a quote with different configuration, without changing the trip details.
      </div>

      <div class="d-flex align-items-center gap-5 flex-wrap mb-3">  
        <div>
          <div class="text-muted small text-uppercase fw-semibold" style="font-size:10px; letter-spacing:0.5px;">
            Quotation No</div>
          <div class="fw-bold">{{ formatQuotationNo(trip.QuotationNo) }}</div>
        </div>
        <div>
          <div class="text-muted small text-uppercase fw-semibold" style="font-size:10px; letter-spacing:0.5px;">
            Destination</div>
          <div class="fw-bold">{{ trip.DestinationName }}</div>
        </div>
        <div>
          <div class="text-muted small text-uppercase fw-semibold" style="font-size:10px; letter-spacing:0.5px;">Start
            Date</div>
          <div class="fw-bold">{{ trip.StartDate | date:'dd MMM, yyyy' }}</div>
        </div>
        <div>
          <div class="text-muted small text-uppercase fw-semibold" style="font-size:10px; letter-spacing:0.5px;">
            Duration</div>
          <div class="fw-bold">
            {{ trip.NoOfNights }} Night{{ trip.NoOfNights > 1 ? 's' : '' }},
            {{ trip.NoOfNights + 1 }} Days
          </div>
        </div>
        <div>
          <div class="text-muted small text-uppercase fw-semibold" style="font-size:10px; letter-spacing:0.5px;">PAX
          </div>
          <div class="fw-bold">{{ paxLabel }}</div>
        </div>
        <button class="btn btn-link btn-sm text-primary p-0" (click)="editBasicDetail(QueryStepOneId)"
          style="font-size:13px; text-decoration:none;">
          Edit Basic Details
        </button>
      </div>

      <!-- Package Types row -->
      <div class="border rounded px-3 py-2 d-flex align-items-center gap-3" style="background:#f8f9fa; font-size:13px;">
        <span class="fw-medium">
          Package Types/Categories:
          <strong>{{ packageTypes().length }} Option{{ packageTypes().length !== 1 ? 's' : '' }}</strong>
        </span>
        <button mat-icon-button style="width:24px;height:24px;line-height:24px;" (click)="openPkgModal()"
          matTooltip="Edit package types">
          <mat-icon style="font-size:14px;">edit</mat-icon>
        </button>


      </div>
    </div>

    <!-- ── Body ──────────────────────────────────────────── -->
    <div style="padding: 20px 0;">

      <!-- ═══════════════════════════════════════════════════ -->
      <!-- HOTELS SECTION                                       -->
      <!-- ═══════════════════════════════════════════════════ -->
      <div class="bg-white border-bottom px-4 py-3">
        <div class="card-body">
          <div class="d-flex align-items-start gap-3 mb-3">
            <div class="bg-primary rounded-circle d-flex align-items-center
                      justify-content-center text-white flex-shrink-0" style="width:40px; height:40px;">
              <i class="bx bx-hotel fs-5"></i>
            </div>
            <div>
              <div class="fw-bold fs-6">Hotels</div>
              <div class="text-muted small">
                Please add hotels details (if included in package) with services
                provided for each hotels and the selling cost price.
              </div>
            </div>
          </div>
          <!-- Package Type Dropdown Selector -->
          <div class="d-flex align-items-center gap-2 mb-3">
            <label class="text-muted small fw-semibold mb-0">Option:</label>
            <select class="form-select form-select-sm" style="width: 220px;" [ngModel]="activePackageTypeId()"
              (ngModelChange)="setActivePackage($event)">
              @for (pkg of packageTypes(); track pkg.QuotePackageTypeId) {
              <option [ngValue]="pkg.QuotePackageTypeId">
                {{ $index + 1 }}: {{ pkg.PackageTypeName }}
              </option>
              }
            </select>
          </div>
          @for (row of getActiveHotelRows(); track row) {
          <div class="border rounded mb-3 p-3 bg-white">


            <!-- LEFT: config | RIGHT: price panel -->
            <div class="row g-2 align-items-start mb-3 pb-3 border-bottom">

              <!-- LEFT: Hotel config (col-8) -->
              <div class="col-sm-8">

                <!-- Hotel / Meal / RoomType / Remove row -->
                <div class="row g-2 mb-2">
                  <div class="col-sm-2">
                    <label class="form-label small text-muted mb-1">Nights</label>
                    <div style="position:relative;">
                      <button type="button"
                        class="form-control form-control-sm text-start d-flex align-items-center justify-content-between"
                        style="background:#fff; border:1px solid #dee2e6; padding:0.25rem 0.5rem;"
                        (click)="toggleHotelNightDropdown(row)">
                        <span style="font-size:13px;">
                          @if (row.SelectedNightsDisplay) {
                          {{ row.SelectedNightsDisplay }}
                          } @else {
                          <span class="text-muted">Select nights</span>
                          }
                        </span>
                        <i class="bx bx-chevron-down" style="font-size:16px;"></i>
                      </button>

                      @if (row.ShowNightDropdown) {
                      <!-- Backdrop — closes on outside click -->
                      <div style="position:fixed; top:0; left:0; right:0; bottom:0; z-index:999;"
                        (click)="closeHotelNightDropdown(row)"></div>

                      <!-- Dropdown -->
                      <div class="border rounded bg-white shadow-sm" style="position:absolute; top:100%; left:0; right:0;
              z-index:1000; max-height:200px; overflow-y:auto;">
                        @for (night of nightSlots(); track night.NightNumber) {
                        <label class="px-3 py-2 mb-0 d-flex align-items-center gap-2"
                          style="font-size:13px; cursor:pointer; border-bottom:1px solid #f0f0f0;">
                          <input type="checkbox" [checked]="row.NightNumbers.includes(night.NightNumber)"
                            (change)="onHotelNightToggle(row, night.NightNumber)" style="cursor:pointer;">
                          <span>Night {{ night.NightNumber }} — {{ night.DateLabel }}</span>
                        </label>
                        }
                        <div class="px-3 py-2 border-top text-end">

                        </div>
                      </div>
                      }
                    </div>
                  </div>

                  <div class="col-sm-4">
                    <label class="form-label small text-muted mb-1">Hotel</label>
                    <div style="position:relative;">
                      <input type="text" class="form-control form-control-sm" placeholder="Search hotel…"
                        [(ngModel)]="row.HotelSearch" (ngModelChange)="onHotelSearch(row)" (focus)="onHotelSearch(row)"
                        (blur)="onHotelBlur(row)" autocomplete="off">

                      @if(row.HotelSearch.length >0){
                      <button type="button" class="btn btn-sm p-0 border-0 bg-transparent" style="
              position:absolute;
              top:50%;
              right:8px;
              transform:translateY(-50%);
              font-size:14px;
              line-height:1;
              z-index:10;
              color:#999;
            " (mousedown)="clearHotel(row)">
                        ×
                      </button>
                      }

                      @if (row.ShowDropdown && row.FilteredHotels.length > 0) {
                      <div class="border rounded bg-white shadow-sm" style="position:absolute; top:100%; left:0; right:0;
                  z-index:1000; max-height:200px; overflow-y:auto;">
                        @for (h of row.FilteredHotels; track h.HotelId) {
                        <div class="px-3 py-2 cursor-pointer" style="font-size:13px; cursor:pointer;"
                          (mousedown)="selectHotel(row, h)">
                          <div class="fw-semibold">{{ h.HotelName }}</div>
                          <div class="text-muted" style="font-size:11px;">
                            {{ h.LocationName }} • {{ h.HotelCategoryName }}
                          </div>
                        </div>
                        }
                      </div>
                      }

                      @if (row.ShowDropdown && row.HotelSearch.length > 0
                      && row.FilteredHotels.length === 0) {

                      <div class="border rounded bg-white shadow-sm" style="position:absolute;
              top:100%;
              left:0;
              right:0;
              z-index:1000;">

                        <!-- No Result -->
                        <div class="px-3 py-1 text-muted" style="font-size:10px;">
                          No hotels found
                        </div>

                        <!-- Add New Hotel -->
                        <div class="px-3 py-2 border-top text-primary" style="font-size:13px;
                cursor:pointer;
                font-weight:500;" (mousedown)="addNewHotel(row)">

                          <i class="bx bx-plus me-1"></i>
                          Add New Hotel "{{ row.HotelSearch }}"
                        </div>

                      </div>
                      }
                    </div>

                    @if (row.HotelId > 0) {
                    <div class="text-muted" style="font-size:11px; margin-top:2px;">
                      {{ row.LocationName }} • {{ row.HotelCategoryName }}
                    </div>
                    }
                  </div>
                  <div class="col-sm-2">
                    <label class="form-label small text-muted mb-1">Meal Plan</label>
                    <select class="form-select form-select-sm" [(ngModel)]="row.MealPlan"
                      (ngModelChange)="markDirty(); row.IsManualPrice = false; lookupHotelRate(row)">
                      <option value="CP">CP</option>
                      <option value="MAP">MAP</option>
                      <option value="AP">AP</option>
                    </select>
                  </div>
                  <div class="col-sm-3">
                    <label class="form-label small text-muted mb-1">Room Type</label>
                    <select class="form-select form-select-sm" [(ngModel)]="row.RoomTypeId"
                      (ngModelChange)="markDirty(); row.IsManualPrice = false; lookupHotelRate(row)">
                      <option [value]="0">Select room…</option>
                      @for (rt of row.RoomTypes; track rt.RoomTypeId) {
                      <option [value]="rt.RoomTypeId">{{ rt.RoomTypeName }}</option>
                      }
                    </select>
                  </div>
                  <div class="col-sm-1 pt-4 text-end">
                    <button mat-icon-button color="warn" (click)="removeHotelRow(row)" matTooltip="Remove">
                      <mat-icon style="font-size:16px;">close</mat-icon>
                    </button>
                  </div>
                </div>

                <!-- Pax row -->
                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <div>
                    <label class="form-label small text-muted mb-1">Pax/room (WoEB)</label>
                    <input type="number" class="form-control form-control-sm" style="width:70px;"
                      [(ngModel)]="row.PaxPerRoom"
                      (ngModelChange)="markDirty(); recalculatePrice(row); hotelRows.update(r=>[...r])" min="1">
                  </div>
                  <div>
                    <label class="form-label small text-muted mb-1">No. of rooms</label>
                    <input type="number" class="form-control form-control-sm" style="width:70px;"
                      [(ngModel)]="row.NoOfRooms"
                      (ngModelChange)="markDirty(); recalculatePrice(row); hotelRows.update(r=>[...r])" min="1">
                  </div>
                  <div>
                    <label class="form-label small text-muted mb-1">AWEB</label>
                    <input type="number" class="form-control form-control-sm" style="width:60px;" [(ngModel)]="row.AWEB"
                      (ngModelChange)="markDirty(); recalculatePrice(row); hotelRows.update(r=>[...r])" min="0">
                  </div>
                  <div>
                    <label class="form-label small text-muted mb-1">CWEB</label>
                    <input type="number" class="form-control form-control-sm" style="width:60px;" [(ngModel)]="row.CWEB"
                      (ngModelChange)="markDirty(); recalculatePrice(row); hotelRows.update(r=>[...r])" min="0">
                  </div>
                  <div>
                    <label class="form-label small text-muted mb-1">CNB</label>
                    <input type="number" class="form-control form-control-sm" style="width:60px;" [(ngModel)]="row.CNB"
                      (ngModelChange)="markDirty(); recalculatePrice(row); hotelRows.update(r=>[...r])" min="0">
                  </div>
                </div>

              </div>
              <!-- RIGHT: Price panel (col-4) - Compact with Date column -->
              <div class="col-sm-4">
                <div class="border rounded p-3 bg-light h-100">
                  <div class="d-flex align-items-center justify-content-between fw-semibold small mb-4">
                    <div class="d-flex align-items-center gap-2">
                      <span>Prices</span>
                      @if (row.IsSaving) {
                      <span class="text-muted" style="font-size:11px;">
                        <i class="bx bx-loader-alt bx-spin"></i> Saving…
                      </span>
                      }
                    </div>
                    <button mat-icon-button (click)="EditPrices(row)" matTooltip="Edit prices">
                      <mat-icon style="font-size:14px;">edit</mat-icon>
                    </button>
                  </div>

                  <table class="table table-sm mb-2" style="font-size:12px;">
                    <thead>
                      <tr class="text-muted">
                        <th>Night</th>
                        <th>Date</th>
                        <th class="text-end">Rate</th>
                        <th class="text-end">Qty</th>
                        <th class="text-end">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- Loop through each night -->
                      @for (night of row.NightNumbers; track night) {
                      @let nightSlot = nightSlots()[night - 1];

                      <!-- Rooms row -->
                      <tr>
                        <td class="fw-semibold text-primary">Night {{ night }}</td>
                        <td class="text-muted small">{{ nightSlot?.DateLabel || '' }}</td>
                        <td class="text-end">{{ formatCurrency(row.BaseRate) }}</td>
                        <td class="text-end">{{ row.NoOfRooms }}</td>
                        <td class="text-end fw-semibold">{{ formatCurrency(row.BaseRate * row.NoOfRooms) }}</td>
                      </tr>

                      <!-- AWEB -->
                      @if (row.AWEB > 0 && row.AwebRate > 0) {
                      <tr>
                        <td></td>
                        <td class="text-muted small">AWEB</td>
                        <td class="text-end">{{ formatCurrency(row.AwebRate) }}</td>
                        <td class="text-end">{{ row.AWEB }}</td>
                        <td class="text-end">{{ formatCurrency(row.AwebRate * row.AWEB) }}</td>
                      </tr>
                      }

                      <!-- CWEB -->
                      @if (row.CWEB > 0 && row.CwebRate > 0) {
                      <tr>
                        <td></td>
                        <td class="text-muted small">CWEB</td>
                        <td class="text-end">{{ formatCurrency(row.CwebRate) }}</td>
                        <td class="text-end">{{ row.CWEB }}</td>
                        <td class="text-end">{{ formatCurrency(row.CwebRate * row.CWEB) }}</td>
                      </tr>
                      }

                      <!-- CNB -->
                      @if (row.CNB > 0 && row.CnbRate > 0) {
                      <tr>
                        <td></td>
                        <td class="text-muted small">CNB</td>
                        <td class="text-end">{{ formatCurrency(row.CnbRate) }}</td>
                        <td class="text-end">{{ row.CNB }}</td>
                        <td class="text-end">{{ formatCurrency(row.CnbRate * row.CNB) }}</td>
                      </tr>
                      }
                      }
                    </tbody>
                    <tfoot>
                      <tr class="border-top">
                        <td colspan="4" class="fw-bold">Total ({{ row.NightNumbers.length }} Nights)</td>
                        <td class="text-end fw-bold text-primary">INR {{ formatCurrency(row.TotalPrice) }}</td>
                      </tr>
                    </tfoot>
                  </table>

                  <!-- Selling price override -->
                 <!-- Selling price override -->
@if (row.BaseRate > 0) {
<div class="mt-2">
  <label class="form-label small text-muted mb-1">Final Price (INR) <span class="text-danger">*</span></label>
  <input type="number" class="form-control form-control-sm" 
    [(ngModel)]="row.FinalPrice"
    (ngModelChange)="onFinalPriceChange(row)" 
    (blur)="saveHotelRow(row)">
  <div class="text-muted" style="font-size:10px;">Cost: INR {{ formatCurrency(row.TotalPrice) }}</div>
</div>
}
                </div>
              </div>

            </div>
          

            <!-- Per-hotel similar hotels -->
<div class="mt-2 pt-2 border-top">
  <div class="d-flex align-items-center justify-content-between mb-2">
    @if (row.SimilarHotels && row.SimilarHotels.length > 0) {
      <span class="text-muted small">
        {{ row.SimilarHotels.length }} similar option(s) —
        effective price:
        <strong class="text-primary">
          INR {{ formatCurrency(effectivePriceForGroup(row)) }}
        </strong>
      </span>
      <button class="btn btn-link btn-sm p-0 text-primary" style="font-size:12px; text-decoration:none;"
        (click)="openSimilarHotelsModal(row)">
        <i class="bx bx-edit me-1"></i> Edit Similar Hotels
      </button>
    } @else {
      <span></span>
      <button class="btn btn-outline-success btn-sm" style="font-size:12px;"
        (click)="openSimilarHotelsModal(row)">
        <i class="bx bx-copy me-1"></i> Add Similar Hotels
      </button>
    }
  </div>

  @if (row.SimilarHotels && row.SimilarHotels.length > 0) {
    <div class="border rounded overflow-hidden ms-3">
      @for (sim of row.SimilarHotels; track sim.QuoteHotelId) {
        <div class="d-flex align-items-center px-3 py-2 border-bottom"
             style="font-size:13px; background:#fafafa;">

          <div style="width:4px; height:36px; background:#6ea8fe;
                      border-radius:2px; margin-right:12px; flex-shrink:0;"></div>

          <div style="flex:2; min-width:0;">
            <div class="fw-semibold text-truncate">{{ sim.HotelName }}</div>
            <div class="text-muted" style="font-size:11px;">
              {{ sim.LocationName }}
              @if (sim.HotelCategoryName) { • {{ sim.HotelCategoryName }} }
            </div>
          </div>

          <div style="flex:2; min-width:0;" class="text-muted">
            {{ sim.NoOfRooms }} {{ sim.RoomTypeName }} ({{ sim.PaxPerRoom }}A)
            <div style="font-size:11px;">{{ sim.MealPlan }}</div>
          </div>

          <div style="flex:1;" class="text-end">
            <span class="text-primary fw-semibold">
              INR {{ formatCurrency(sim.SellingPrice || sim.TotalPrice) }}
            </span>
          </div>

          <div>
            <button mat-icon-button color="warn"
                    style="width:24px; height:24px; line-height:24px;"
                    (click)="removeSimilarHotel(row, sim)"
                    matTooltip="Remove">
              <mat-icon style="font-size:14px;">close</mat-icon>
            </button>
          </div>

        </div>
      }
    </div>
  }
</div>
          </div>
          }
          <div class="d-flex gap-2 mt-2 flex-wrap">

            @if (getActiveHotelRows().length === 0) {
            <button class="btn btn-outline-primary btn-sm" style="font-size:12px;" (click)="addHotelRow()">
              <i class="bx bx-plus me-1"></i> Add Hotel
            </button>
            }

            @if (hasSelectedNight() && getNextUnselectedNight() !== null) {
            <button class="btn btn-outline-secondary btn-sm" style="font-size:12px;"
              (click)="addHotelRowForNextNight()">
              <i class="bx bx-chevron-right me-1"></i>
              Next Night (Night {{ getNextUnselectedNight() }})
            </button>
            }

            <!-- @if (getActiveHotelRows().length > 0) {
            <button class="btn btn-outline-success btn-sm" style="font-size:12px;" (click)="openSimilarHotelsModal()">
              <i class="bx bx-copy me-1"></i>
              Add Similar Hotels
            </button>
            } -->



          </div>
          <!-- Similar Hotels Summary List -->
          @if (getSimilarHotelRows().length > 0) {
          <div class="mt-3">

          </div>
          }










          <!-- ════════════════════════════════════════════════════════ -->
          <!-- SIMILAR HOTELS MODAL                                      -->
          <!-- ════════════════════════════════════════════════════════ -->
          @if (showSimilarHotelsModal && similarHotelSourceRow) {
          <div class="modal-backdrop fade show" style="z-index:1060; backdrop-filter:blur(3px);"
            (click)="closeSimilarHotelsModal()"></div>
          <div class="modal fade show d-block" style="z-index:1070;" tabindex="-1">
            <div class="modal-dialog modal-xl modal-dialog-centered">
              <div class="modal-content border-0 shadow-lg">

                <div class="modal-header border-bottom px-4 py-3">
                  <h5 class="modal-title fw-bold" style="font-size:15px;">Add Similar Hotels</h5>
                  <button type="button" class="btn-close" (click)="closeSimilarHotelsModal()"></button>
                </div>

                <div class="modal-body px-4 py-3" style="max-height:75vh; overflow-y:auto;">

                  <!-- Source hotel summary bar -->
                  <div class="border rounded px-4 py-3 mb-4" style="background:#f8f9fa;">
                    <div class="row g-3">
                      <div class="col-sm-3">
                        <div class="text-muted small">Nights</div>
                        <div class="fw-semibold small">{{ similarHotelSourceRow.SelectedNightsDisplay }}</div>
                      </div>
                      <div class="col-sm-3">
                        <div class="text-muted small">Hotel Name</div>
                        <div class="fw-semibold small">{{ similarHotelSourceRow.HotelName || '—' }}</div>
                        @if (similarHotelSourceRow.LocationName) {
                        <div class="text-muted" style="font-size:11px;">
                          {{ similarHotelSourceRow.LocationName }}
                          @if (similarHotelSourceRow.HotelCategoryName) {
                          • {{ similarHotelSourceRow.HotelCategoryName }}
                          }
                        </div>
                        }
                      </div>
                      <div class="col-sm-3">
                        <div class="text-muted small">Meal Plan</div>
                        <div class="fw-semibold small">{{ similarHotelSourceRow.MealPlan }}</div>
                      </div>
                      <div class="col-sm-3">
                        <div class="text-muted small">Rooms</div>
                        <div class="fw-semibold small">
                          {{ similarHotelSourceRow.NoOfRooms }} × {{ similarHotelSourceRow.RoomTypeName }}
                        </div>
                        <div class="text-muted" style="font-size:11px;">
                          {{ similarHotelSourceRow.PaxPerRoom }} Pax/room
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Similar hotel rows -->
                  @for (row of similarHotelRows; track $index; let i = $index) {
                  <div class="border rounded p-3 mb-3 bg-white">
                    <div class="row g-2 align-items-start">

                      <!-- Hotel Search -->
                      <div class="col-sm-3">
                        <label class="form-label small text-muted mb-1">Hotel</label>
                        <div style="position:relative;">
                          <input type="text" class="form-control form-control-sm" placeholder="Type to search..."
                            [(ngModel)]="row.HotelSearch" (ngModelChange)="onSimilarHotelSearch(row)"
                            (focus)="onSimilarHotelSearch(row)" (blur)="onSimilarHotelBlur(row)" autocomplete="off">
                          @if (row.HotelSearch.length > 0) {
                          <button type="button" class="btn btn-sm p-0 border-0 bg-transparent" style="position:absolute; top:50%; right:8px;
                                     transform:translateY(-50%); font-size:14px;
                                     line-height:1; z-index:10; color:#999;"
                            (mousedown)="clearSimilarHotel(row)">×</button>
                          }
                          @if (row.ShowDropdown && row.FilteredHotels.length > 0) {
                          <div class="border rounded bg-white shadow-sm" style="position:absolute; top:100%; left:0; right:0;
                                  z-index:1080; max-height:180px; overflow-y:auto;">
                            @for (h of row.FilteredHotels; track h.HotelId) {
                            <div class="px-3 py-2" style="font-size:13px; cursor:pointer;"
                              (mousedown)="selectSimilarHotel(row, h)">
                              <div class="fw-semibold">{{ h.HotelName }}</div>
                              <div class="text-muted" style="font-size:11px;">
                                {{ h.LocationName }} • {{ h.HotelCategoryName }}
                              </div>
                            </div>
                            }
                          </div>
                          }
                        </div>
                        @if (row.HotelId > 0) {
                        <div class="text-muted" style="font-size:11px; margin-top:2px;">
                          {{ row.LocationName }} • {{ row.HotelCategoryName }}
                        </div>
                        }
                      </div>

                      <!-- Meal Plan -->
                      <div class="col-sm-2">
                        <label class="form-label small text-muted mb-1">Meal Plan</label>
                        <select class="form-select form-select-sm" [(ngModel)]="row.MealPlan"
                          (ngModelChange)="lookupSimilarHotelRate(row); similarHotelRows = [...similarHotelRows]">
                          <option value="CP">CP</option>
                          <option value="MAP">MAP</option>
                          <option value="AP">AP</option>
                        </select>
                      </div>

                      <!-- Room Type -->
                      <div class="col-sm-2">
                        <label class="form-label small text-muted mb-1">Room Type</label>
                        <select class="form-select form-select-sm" [(ngModel)]="row.RoomTypeId"
                          (ngModelChange)="lookupSimilarHotelRate(row); similarHotelRows = [...similarHotelRows]">
                          <option [value]="0">Select room…</option>
                          @for (rt of row.RoomTypes; track rt.RoomTypeId) {
                          <option [value]="rt.RoomTypeId">{{ rt.RoomTypeName }}</option>
                          }
                        </select>
                      </div>

                      <!-- Remove -->
                      <div class="col-auto pt-4">
                        <button mat-icon-button color="warn" style="width:24px; height:24px; line-height:24px;"
                          (click)="removeSimilarHotelRow(i)">
                          <mat-icon style="font-size:14px;">close</mat-icon>
                        </button>
                      </div>

                      <!-- Pax row -->
                      <div class="col-12">
                        <div class="d-flex align-items-center gap-2 flex-wrap">
                          <div>
                            <label class="form-label small text-muted mb-1">No. of Nights</label>
                            <input type="text" class="form-control form-control-sm"
                              style="width:70px; background:#f8f9fa;" [value]="row.NightNumbers.length" readonly>
                          </div>
                          <div>
                            <label class="form-label small text-muted mb-1">Pax/room</label>
                            <input type="number" class="form-control form-control-sm" style="width:70px;"
                              [(ngModel)]="row.PaxPerRoom"
                              (ngModelChange)="calculateSimilarHotelPrice(row); similarHotelRows = [...similarHotelRows]" min="1">
                          </div>
                          <div>
                            <label class="form-label small text-muted mb-1">No. of rooms</label>
                            <input type="number" class="form-control form-control-sm" style="width:70px;"
                              [(ngModel)]="row.NoOfRooms"
                              (ngModelChange)="calculateSimilarHotelPrice(row); similarHotelRows = [...similarHotelRows]" min="1">
                          </div>
                          <div>
                            <label class="form-label small text-muted mb-1">AWEB</label>
                            <input type="number" class="form-control form-control-sm" style="width:60px;"
                              [(ngModel)]="row.AWEB"
                              (ngModelChange)="calculateSimilarHotelPrice(row); similarHotelRows = [...similarHotelRows]" min="0">
                          </div>
                          <div>
                            <label class="form-label small text-muted mb-1">CWEB</label>
                            <input type="number" class="form-control form-control-sm" style="width:60px;"
                              [(ngModel)]="row.CWEB"
                              (ngModelChange)="calculateSimilarHotelPrice(row); similarHotelRows = [...similarHotelRows]" min="0">
                          </div>
                          <div>
                            <label class="form-label small text-muted mb-1">CNB</label>
                            <input type="number" class="form-control form-control-sm" style="width:60px;"
                              [(ngModel)]="row.CNB"
                              (ngModelChange)="calculateSimilarHotelPrice(row); similarHotelRows = [...similarHotelRows]" min="0">
                          </div>
                        </div>
                      </div>

                      <!-- Price Panel -->
                      <div class="col-12 mt-2">
                        <div class="border rounded p-3 bg-light">
                          <div class="d-flex align-items-center justify-content-between fw-semibold small mb-3">
                            <div class="d-flex align-items-center gap-2">
                              <span>Prices</span>
                              @if (row.IsSaving) {
                              <span class="text-muted" style="font-size:11px;">
                                <i class="bx bx-loader-alt bx-spin"></i> Saving…
                              </span>
                              }
                            </div>
                          </div>
<!-- Edit Price Button -->
<div class="col-12 mt-2">
  <button class="btn btn-warning btn-sm" style="font-size:12px;"
    (click)="openSimilarHotelEditPriceModal(row)">
    <mat-icon style="font-size:14px; width:14px; height:14px; margin-right:4px;">edit</mat-icon>
    Edit Prices
  </button>
</div>
                          <table class="table table-sm mb-2" style="font-size:12px;">
                            <thead>
                              <tr class="text-muted">
                                <th>Night</th>
                                <th>Date</th>
                                <th class="text-end">Rate</th>
                                <th class="text-end">Qty</th>
                                <th class="text-end">Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (night of row.NightNumbers; track night) {
                              @let nightSlotData = nightSlots()[night - 1];
                              <tr>
                                <td class="fw-semibold text-primary">Night {{ night }}</td>
                                <td class="text-muted small">{{ nightSlotData?.DateLabel || '' }}</td>
                                <td class="text-end">{{ formatCurrency(row.BaseRate) }}</td>
                                <td class="text-end">{{ row.NoOfRooms }}</td>
                                <td class="text-end fw-semibold">
                                  {{ formatCurrency(row.BaseRate * row.NoOfRooms) }}
                                </td>
                              </tr>
                              @if (row.AWEB > 0 && row.AwebRate > 0) {
                              <tr>
                                <td></td>
                                <td class="text-muted small">AWEB</td>
                                <td class="text-end">{{ formatCurrency(row.AwebRate) }}</td>
                                <td class="text-end">{{ row.AWEB }}</td>
                                <td class="text-end">{{ formatCurrency(row.AwebRate * row.AWEB) }}</td>
                              </tr>
                              }
                              @if (row.CWEB > 0 && row.CwebRate > 0) {
                              <tr>
                                <td></td>
                                <td class="text-muted small">CWEB</td>
                                <td class="text-end">{{ formatCurrency(row.CwebRate) }}</td>
                                <td class="text-end">{{ row.CWEB }}</td>
                                <td class="text-end">{{ formatCurrency(row.CwebRate * row.CWEB) }}</td>
                              </tr>
                              }
                              @if (row.CNB > 0 && row.CnbRate > 0) {
                              <tr>
                                <td></td>
                                <td class="text-muted small">CNB</td>
                                <td class="text-end">{{ formatCurrency(row.CnbRate) }}</td>
                                <td class="text-end">{{ row.CNB }}</td>
                                <td class="text-end">{{ formatCurrency(row.CnbRate * row.CNB) }}</td>
                              </tr>
                              }
                              }
                            </tbody>
                            <tfoot>
                              <tr class="border-top">
                                <td colspan="4" class="fw-bold">
                                  Total ({{ row.NightNumbers.length }} Night{{ row.NightNumbers.length !== 1 ? 's' : ''
                                  }})
                                </td>
                                <td class="text-end fw-bold text-primary">
                                  INR {{ formatCurrency(row.TotalPrice) }}
                                </td>
                              </tr>
                            </tfoot>
                          </table>

                          @if (row.BaseRate > 0) {
                          <div class="mt-2">
                            <label class="form-label small text-muted mb-1">
                              Final Price (INR) <span class="text-danger">*</span>
                            </label>
                            <input type="number" class="form-control form-control-sm" [(ngModel)]="row.SellingPrice"
                              (ngModelChange)="onSimilarHotelSellingPriceChange(row)">
                            <div class="text-muted" style="font-size:10px; margin-top:2px;">
                              Cost: INR {{ formatCurrency(row.TotalPrice) }}
                            </div>
                          </div>
                          }
                        </div>
                      </div>

                    </div>
                  </div>
                  }

                  <button class="btn btn-outline-primary btn-sm mt-1" style="font-size:12px;"
                    (click)="addSimilarHotelRow()">
                    <i class="bx bx-plus me-1"></i> Add More Hotel
                  </button>

                </div>

                <div class="modal-footer border-top px-4 py-3">
                  <button class="btn btn-outline-secondary btn-sm px-3"
                    (click)="closeSimilarHotelsModal()">Cancel</button>
                  <button class="btn btn-primary btn-sm px-4" (click)="saveSimilarHotels()">Save</button>
                </div>

              </div>
            </div>
          </div>
          }

<!-- Similar Hotel Edit Prices Modal -->
@if (showSimilarHotelEditPriceModal && editingSimilarHotelRow) {
<div class="modal-backdrop fade show" style="z-index:1060; backdrop-filter:blur(3px);"></div>
<div class="modal fade show d-block" style="z-index:1070;" tabindex="-1">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg">

      <div class="modal-header border-bottom px-4 py-3">
        <div>
          <h5 class="modal-title fw-bold mb-0" style="font-size:15px;">
            Edit Prices - Similar Hotel
          </h5>
          <div class="text-muted" style="font-size:12px;">
            {{ editingSimilarHotelRow.HotelName }} •
            {{ editingSimilarHotelRow.MealPlan }} •
            {{ editingSimilarHotelRow.RoomTypeName }}
          </div>
        </div>
        <button type="button" class="btn-close" (click)="closeSimilarHotelEditPriceModal()"></button>
      </div>

      <div class="modal-body px-4 py-3">

        <table class="table table-sm table-bordered" style="font-size:13px;">
          <thead class="table-light">
            <tr>
              <th>Type</th>
              <th class="text-end">System Rate</th>
              <th class="text-end">Qty</th>
              <th class="text-end">Given Rate</th>
              <th class="text-end">Total</th>
            </tr>
          </thead>
          <tbody>

            <!-- Rooms -->
            <tr>
              <td class="align-middle">
                Rooms
                <div class="text-muted" style="font-size:10px;">per room/night</div>
              </td>
              <td class="text-end align-middle text-muted">
                {{ formatCurrency(editingSimilarHotelRow.BaseRate) }}
              </td>
              <td class="align-middle" style="width:60px;">
                <input type="number" class="form-control form-control-sm text-end"
                  [(ngModel)]="editingSimilarHotelRow.NoOfRooms" (ngModelChange)="recalculateEditSimilarHotelPrice()" min="1"
                  style="width:60px;">
              </td>
              <td class="align-middle" style="width:110px;">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editSimilarHotelPrices.RoomRate"
                  (ngModelChange)="recalculateEditSimilarHotelPrice()" min="0" style="width:110px;">
              </td>
              <td class="text-end align-middle fw-semibold">
                {{ formatCurrency(editSimilarHotelPrices.RoomRate * editingSimilarHotelRow.NoOfRooms * (editingSimilarHotelRow.NightNumbers.length || 1)) }}
              </td>
            </tr>

            <!-- AWEB -->
            <tr>
              <td class="align-middle">
                AWEB
              </td>
              <td class="text-end align-middle text-muted">
                {{ formatCurrency(editingSimilarHotelRow.AwebRate) }}
              </td>
              <td class="align-middle">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editingSimilarHotelRow.AWEB"
                  (ngModelChange)="recalculateEditSimilarHotelPrice()" min="0" style="width:60px;">
              </td>
              <td class="align-middle">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editSimilarHotelPrices.AwebRate"
                  (ngModelChange)="recalculateEditSimilarHotelPrice()" min="0" style="width:110px;">
              </td>
              <td class="text-end align-middle fw-semibold">
                {{ formatCurrency(editSimilarHotelPrices.AwebRate * editingSimilarHotelRow.AWEB) }}
              </td>
            </tr>

            <!-- CWEB -->
            <tr>
              <td class="align-middle">
                CWEB
              </td>
              <td class="text-end align-middle text-muted">
                {{ formatCurrency(editingSimilarHotelRow.CwebRate) }}
              </td>
              <td class="align-middle">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editingSimilarHotelRow.CWEB"
                  (ngModelChange)="recalculateEditSimilarHotelPrice()" min="0" style="width:60px;">
              </td>
              <td class="align-middle">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editSimilarHotelPrices.CwebRate"
                  (ngModelChange)="recalculateEditSimilarHotelPrice()" min="0" style="width:110px;">
              </td>
              <td class="text-end align-middle fw-semibold">
                {{ formatCurrency(editSimilarHotelPrices.CwebRate * editingSimilarHotelRow.CWEB) }}
              </td>
            </tr>

            <!-- CNB -->
            <tr>
              <td class="align-middle">
                CNB
              </td>
              <td class="text-end align-middle text-muted">
                {{ formatCurrency(editingSimilarHotelRow.CnbRate) }}
              </td>
              <td class="align-middle">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editingSimilarHotelRow.CNB"
                  (ngModelChange)="recalculateEditSimilarHotelPrice()" min="0" style="width:60px;">
              </td>
              <td class="align-middle">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editSimilarHotelPrices.CnbRate"
                  (ngModelChange)="recalculateEditSimilarHotelPrice()" min="0" style="width:110px;">
              </td>
              <td class="text-end align-middle fw-semibold">
                {{ formatCurrency(editSimilarHotelPrices.CnbRate * editingSimilarHotelRow.CNB) }}
              </td>
            </tr>

          </tbody>
          <tfoot>
            <tr class="table-light">
              <td colspan="4" class="fw-bold">Cost Total</td>
              <td class="text-end fw-bold">
                INR {{ formatCurrency(editSimilarHotelPrices.ComputedTotal) }}
              </td>
            </tr>
          </tfoot>
        </table>

      </div>

      <div class="modal-footer border-top">
        <button class="btn btn-outline-secondary btn-sm px-3" (click)="closeSimilarHotelEditPriceModal()">Cancel</button>
        <button class="btn btn-primary btn-sm px-4" (click)="applySimilarHotelEditPrices()">
          Apply
        </button>
      </div>

    </div>
  </div>
</div>
}











          <div class="text-muted small fst-italic mt-2">
            No hotels added. Click Add Hotel and select nights.
          </div>


          <!-- Hotel total -->
          <div class="d-flex justify-content-end mt-2">
            <div class="badge bg-warning text-dark px-3 py-2" style="font-size:13px;">
              Accommodations Total: INR {{ formatCurrency(hotelTotal()) }}
            </div>
          </div>
        </div>
      </div>


      <!-- ═══════════════════════════════════════════════════ -->
      <!-- SPECIAL INCLUSIONS SECTION                          -->
      <!-- ═══════════════════════════════════════════════════ -->
      <div class="card border-0 shadow-sm mb-4">
        <div class="card-body">
          <div class="d-flex align-items-start gap-3 mb-3">
            <div class="bg-warning rounded-circle d-flex align-items-center
            justify-content-center text-white flex-shrink-0" style="width:40px; height:40px;">
              <i class="bx bx-star fs-5"></i>
            </div>
            <div>
              <div class="fw-bold fs-6">Any Special Inclusions in Hotels</div>
              <div class="text-muted small">
                Add services and select multiple nights for each service.
              </div>
            </div>
          </div>

          <!-- All inclusion rows (no grouping by night) -->
          @for (row of getActiveSpecialInclusionRows(); track row.QuoteSpecialInclusionId; let idx = $index) {
          <div class="border rounded p-3 mb-3 bg-white position-relative">

            <!-- Remove button — top right -->
            <button mat-icon-button color="warn" class="position-absolute"
              style="top:4px; right:4px; width:24px; height:24px; line-height:24px;"
              (click)="removeSpecialInclusionRow(row)" matTooltip="Remove">
              <mat-icon style="font-size:14px;">close</mat-icon>
            </button>

            <div class="row g-2 align-items-start">

              <!-- Service -->
              <div class="col-sm-3">
                <label class="form-label small text-muted mb-1">Service</label>
                <div style="position:relative;">
                  <input type="text" class="form-control form-control-sm" placeholder="Search service…"
                    [(ngModel)]="row.ServiceSearch" (ngModelChange)="onServiceSearch(row)"
                    (focus)="onServiceSearch(row)" (blur)="onServiceBlur(row)" autocomplete="off">

                  @if (row.ServiceSearch.length > 0) {
                  <button type="button" class="btn btn-sm p-0 border-0 bg-transparent" style="position:absolute; top:50%; right:8px;
                         transform:translateY(-50%); font-size:14px;
                         line-height:1; z-index:10; color:#999;" (mousedown)="clearService(row)">
                    ×
                  </button>
                  }

                  @if (row.ShowServiceDropdown && row.FilteredServices.length > 0) {
                  <div class="border rounded bg-white shadow-sm" style="position:absolute; top:100%; left:0; right:0;
                      z-index:1000; max-height:180px; overflow-y:auto;">
                    @for (svc of row.FilteredServices; track svc.SpecialInclusionTypeId) {
                    <div class="px-3 py-2" style="font-size:13px; cursor:pointer;"
                      (mousedown)="selectService(row, svc)">
                      <div class="fw-semibold">{{ svc.SpecialInclusionTypeName }}</div>
                      @if (getHotelRateForService(row, svc) > 0) {
                      <div class="text-muted" style="font-size:11px;">
                        INR {{ getHotelRateForService(row, svc) | number }}
                      </div>
                      } @else {
                      <div class="text-muted" style="font-size:11px;">
                        No price set — enter manually
                      </div>
                      }
                    </div>
                    }
                  </div>
                  }
                </div>
              </div>

              <!-- Hotel / Manual Location -->
              <div class="col-sm-3">
                <div class="d-flex align-items-center gap-2 mb-1">
                  <label class="form-label small text-muted mb-0">Hotel</label>
                  <button type="button" class="btn btn-sm p-0 border-0 bg-transparent"
                    style="font-size:11px; color:#666; text-decoration:underline;" (click)="toggleManualLocation(row)">
                    @if (row.UseManualLocation) { Select Hotel }
                    @else { Enter Location }
                  </button>
                </div>

                @if (!row.UseManualLocation) {
                <div style="position:relative;">
                  <input type="text" class="form-control form-control-sm" placeholder="Search hotel…"
                    [(ngModel)]="row.HotelSearch" (ngModelChange)="onSpecialInclusionHotelSearch(row)"
                    (focus)="onSpecialInclusionHotelSearch(row)" (blur)="onSpecialInclusionHotelBlur(row)"
                    autocomplete="off">

                  @if (row.HotelSearch.length > 0) {
                  <button type="button" class="btn btn-sm p-0 border-0 bg-transparent" style="position:absolute; top:50%; right:8px;
                           transform:translateY(-50%); font-size:14px;
                           line-height:1; z-index:10; color:#999;" (mousedown)="clearSpecialInclusionHotel(row)">
                    ×
                  </button>
                  }

                  @if (row.ShowHotelDropdown && row.FilteredHotels.length > 0) {
                  <div class="border rounded bg-white shadow-sm" style="position:absolute; top:100%; left:0; right:0;
                        z-index:1000; max-height:180px; overflow-y:auto;">
                    @for (h of row.FilteredHotels; track h.HotelId) {
                    <div class="px-3 py-2" style="font-size:13px; cursor:pointer;"
                      (mousedown)="selectSpecialInclusionHotel(row, h)">
                      <div class="fw-semibold">{{ h.HotelName }}</div>
                      <div class="text-muted" style="font-size:11px;">
                        {{ h.LocationName }} • {{ h.HotelCategoryName }}
                      </div>
                    </div>
                    }
                  </div>
                  }
                </div>
                } @else {
                <input type="text" class="form-control form-control-sm" placeholder="Enter location name…"
                  [(ngModel)]="row.ManualLocationName" (ngModelChange)="onManualLocationChange(row)" autocomplete="off">
                <div class="text-muted" style="font-size:10px; margin-top:2px; font-style:italic;">
                  Manual entry
                </div>
                }
              </div>

              <!-- Night (single select) -->
              <div class="col-sm-2">
                <label class="form-label small text-muted mb-1">Night</label>
                <div style="position:relative;">
                  <button type="button"
                    class="form-control form-control-sm text-start d-flex align-items-center justify-content-between"
                    style="background:#fff; border:1px solid #dee2e6; padding:0.25rem 0.5rem;"
                    (click)="toggleNightDropdown(row)" (blur)="onNightDropdownBlur(row)">
                    <span style="font-size:13px;">
                      @if (row.SelectedNightsDisplay) {
                      {{ row.SelectedNightsDisplay }}
                      } @else {
                      <span class="text-muted">Select night…</span>
                      }
                    </span>
                    <i class="bx bx-chevron-down" style="font-size:16px;"></i>
                  </button>

                  @if (row.ShowNightDropdown) {
                  <div class="border rounded bg-white shadow-sm" style="position:absolute; top:100%; left:0; right:0;
                      z-index:1000; max-height:200px; overflow-y:auto;">
                    @for (slot of nightSlots(); track slot.NightNumber) {
                    <label class="px-3 py-2 mb-0 d-flex align-items-center gap-2"
                      style="font-size:13px; cursor:pointer; border-bottom:1px solid #f0f0f0;">
                      <input type="radio" name="specialInclusionNight_{{ idx }}"
                        [checked]="row.NightNumbers.includes(slot.NightNumber)"
                        (change)="onNightToggle(row, slot.NightNumber)" style="cursor:pointer;">
                      <span>Night {{ slot.NightNumber }} — {{ slot.DateLabel }}</span>
                    </label>
                    }
                  </div>
                  }
                </div>
                @if (row.NightNumbers.length > 0) {
                <div class="text-muted" style="font-size:10px; margin-top:2px;">
                  Night {{ row.NightNumbers[0] }}
                </div>
                }
              </div>

              <!-- Total Price -->
              <div class="col-sm-2">
                <label class="form-label small text-muted mb-1">Price (INR)</label>
                <input type="number" class="form-control form-control-sm" [(ngModel)]="row.TotalPrice"
                  (ngModelChange)="markDirty()" (ngModelChange)="onSpecialInclusionPriceChange(row)"
                  placeholder="e.g. 3000">
              </div>

              <!-- Comments -->
              <div class="col-sm-2">
                <label class="form-label small text-muted mb-1">Comments</label>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="row.Comments"
                  (ngModelChange)="markDirty()" placeholder="Any comments…">
              </div>

              <!-- REMOVED SAVE BUTTON - WILL BE SAVED WITH MAIN QUOTE -->

            </div>
          </div>
          }

          <!-- ── Add Service button ── -->
          @if (getActiveSpecialInclusionRows().length === 0 || getActiveHotelRows().length > 0) {
          <button class="btn btn-outline-secondary btn-sm" style="font-size:12px;" (click)="addSpecialInclusionRow()">
            <i class="bx bx-plus me-1"></i> Add Service
          </button>
          }

          @if (getActiveSpecialInclusionRows().length === 0) {
          <div class="text-muted small fst-italic">
            No special inclusions added. Add hotels first, then add services here.
          </div>
          }

        </div>
      </div>


      <!-- ═══════════════════════════════════════════════════ -->
      <!-- TRANSPORTS & ACTIVITIES SECTION                      -->
      <!-- ═══════════════════════════════════════════════════ -->

      <div class="bg-white border-bottom px-4 py-3">
        <div class="card-body">
          <div class="d-flex align-items-start gap-3 mb-3">
            <div class="bg-primary rounded-circle d-flex align-items-center
                  justify-content-center text-white flex-shrink-0" style="width:40px; height:40px;">
              <i class="bx bx-car fs-5"></i>
            </div>
            <div>
              <div class="fw-bold fs-6">Transports and Activities</div>
              <div class="text-muted small">
                Please add the transportation services and Activities (if included) details and the selling cost price
                for each service.
              </div>
              <div class="text-muted small mt-1">
                <i class="bx bx-info-circle" style="font-size:13px;"></i>
                Tip: To speed up the process of adding multiple services, use Next Day or Duplicate actions.
              </div>
            </div>
          </div>

          <!-- Same Cab Type for All - Global setting -->
          <div class="mb-4 p-2 border rounded d-flex align-items-center gap-3" style="background:#f0f7ff;">
            <div class="form-check mb-0">
              <input class="form-check-input" type="checkbox" id="sameCab" [(ngModel)]="sameCabForAll"
                (change)="onSameCabChange()">
              <label class="form-check-label fw-medium" for="sameCab" style="font-size:13px;">
                Same Cab Type for All
              </label>
            </div>

            @if (sameCabForAll && selectedCabTypes.length > 0) {
            <div class="d-flex align-items-center gap-2">
              <span style="font-size:13px;" class="text-primary fw-semibold">
                {{ getSelectedCabTypesDisplay() }}
              </span>
              <button type="button" class="btn btn-link p-0 border-0 bg-transparent"
                style="font-size:12px; color:#0d6efd; cursor:pointer;" (click)="openCabTypesModal()">
                <i class="bx bx-edit" style="font-size:14px;"></i>
              </button>
            </div>
            }

            @if (sameCabForAll && selectedCabTypes.length === 0) {
            <button type="button" class="btn btn-link p-0 border-0 text-primary"
              style="font-size:12px; text-decoration:none;" (click)="openCabTypesModal()">
              <i class="bx bx-plus me-1"></i> Select Cab Types
            </button>
            }
          </div>

          <!-- INDEPENDENT TRANSPORT ROWS (like Hotels) -->
          @for (group of getActiveDayGroups(); track group.GroupId) {
          <div class="border rounded mb-4 p-3" style="background:#fafbfc;">

            <!-- Group header: Days selector + Remove -->
            <div class="d-flex align-items-center justify-content-between mb-3">
              <div style="width:220px;">
                <label class="form-label small text-muted mb-1">Days</label>
                <div style="position:relative;">
                  <button type="button"
                    class="form-control form-control-sm text-start d-flex align-items-center justify-content-between"
                    style="background:#fff; border:1px solid #dee2e6; padding:0.25rem 0.5rem;"
                    (click)="toggleDayGroupDayDropdown(group)">
                    <span style="font-size:13px;">
                      @if (group.SelectedDaysDisplay) { {{ group.SelectedDaysDisplay }} } @else { <span
                        class="text-muted">Select day(s)…</span> }
                    </span>
                    <i class="bx bx-chevron-down" style="font-size:16px;"></i>
                  </button>
                  @if (group.ShowDayDropdown) {
                  <div style="position:fixed; top:0; left:0; right:0; bottom:0; z-index:999;"
                    (click)="closeDayGroupDayDropdown(group)"></div>
                  <div class="border rounded bg-white shadow-sm"
                    style="position:absolute; top:100%; left:0; right:0; z-index:1000; max-height:220px; overflow-y:auto;">
                    @for (slot of daySlots(); track slot.DayNumber) {
                    <label class="px-3 py-2 mb-0 d-flex align-items-center gap-2"
                      style="font-size:13px; cursor:pointer; border-bottom:1px solid #f0f0f0;">
                      <input type="checkbox" [checked]="group.DayNumbers.includes(slot.DayNumber)"
                        (change)="onDayGroupDayToggle(group, slot.DayNumber)" style="cursor:pointer;">
                      <span>Day {{ slot.DayNumber }} — {{ slot.DateLabel }}</span>
                    </label>
                    }
                  </div>
                  }
                </div>
              </div>
              <button type="button" class="btn btn-link btn-sm p-0 text-danger"
                style="font-size:12px; text-decoration:none;" (click)="removeDayGroup(group)">
                <i class="bx bx-trash me-1"></i> Remove Day
              </button>
            </div>

            <!-- Transport rows belonging to THIS group only -->
            @for (row of group.TransportRows; track row.QuoteServiceId) {
            <div class="border rounded mb-3 p-3 bg-white">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="d-flex align-items-center gap-2 text-primary fw-semibold" style="font-size:13px;">
                  <i class="bx bx-car"></i> Transport Service
                </div>
                <button mat-icon-button color="warn" (click)="removeTransportRowFromGroup(group, row)"
                  matTooltip="Remove">
                  <mat-icon style="font-size:16px;">close</mat-icon>
                </button>
              </div>

              <div class="row g-2 align-items-start">
                <div class="col-sm-8">
                  <div class="row g-3 mb-2 align-items-start">

                    <!-- Location -->
                    <div class="col-sm-6">
                      <label class="form-label small text-muted mb-1">Location</label>
                      <div style="position:relative;">
                        <input type="text" class="form-control form-control-sm" placeholder="Search location…"
                          [(ngModel)]="row.LocationSearch" (ngModelChange)="onTransportLocationSearch(row)"
                          (focus)="onTransportLocationSearch(row)" (blur)="onTransportLocationBlur(row)"
                          autocomplete="off">
                        @if(row.LocationSearch.length > 0) {
                        <button type="button" class="btn btn-sm p-0 border-0 bg-transparent"
                          style="position:absolute; top:50%; right:8px; transform:translateY(-50%); font-size:14px; z-index:10; color:#999;"
                          (mousedown)="clearTransportLocationRow(row)">×</button>
                        }
                        @if (row.ShowLocationDropdown && row.FilteredLocations.length > 0) {
                        <div class="border rounded bg-white shadow-sm"
                          style="position:absolute; top:100%; left:0; right:0; z-index:1000; max-height:200px; overflow-y:auto;">
                          @for (loc of row.FilteredLocations; track loc.LocationId) {
                          <div class="px-3 py-2" style="font-size:13px; cursor:pointer;"
                            (mousedown)="selectTransportLocationRow(row, loc)">
                            <div class="fw-semibold">{{ loc.LocationName }}</div>
                          </div>
                          }
                        </div>
                        }
                      </div>
                      @if (row.LocationId > 0) {
                      <div class="text-muted" style="font-size:11px; margin-top:2px;">{{ row.LocationName }}</div>
                      }

                      <label class="form-label small text-muted mb-1 mt-2">Service</label>
                      <div style="position:relative;">
                        <input type="text" class="form-control form-control-sm" placeholder="Search service…"
                          [(ngModel)]="row.ServiceSearch" (ngModelChange)="onTransportServiceSearch(row)"
                          (focus)="onTransportServiceSearch(row)" (blur)="onTransportServiceBlur(row)"
                          autocomplete="off" [disabled]="!row.LocationId">
                        @if(row.ServiceSearch.length > 0) {
                        <button type="button" class="btn btn-sm p-0 border-0 bg-transparent"
                          style="position:absolute; top:50%; right:8px; transform:translateY(-50%); font-size:14px; z-index:10; color:#999;"
                          (mousedown)="clearTransportServiceRow(row)">×</button>
                        }
                        @if (row.ShowServiceDropdown && row.FilteredServices.length > 0) {
                        <div class="border rounded bg-white shadow-sm"
                          style="position:absolute; top:100%; left:0; right:0; z-index:1000; max-height:200px; overflow-y:auto;">
                          @for (svc of row.FilteredServices; track svc.IteneraryServiceId) {
                          <div class="px-3 py-2" style="font-size:13px; cursor:pointer;"
                            (mousedown)="selectTransportServiceRow(row, svc)">
                            <div class="fw-semibold">{{ svc.IteneraryServiceName }}</div>
                          </div>
                          }
                        </div>
                        }
                      </div>
                      @if (!row.LocationId) {
                      <div class="text-muted" style="font-size:10px; margin-top:2px;">Select location first</div>
                      }
                    </div>

                    <!-- Vehicle -->
                    <div class="col-sm-6">
                      <label class="form-label small text-muted mb-1">Vehicle</label>
                      @if (sameCabForAll) {
                      <div
                        class="form-control form-control-sm d-flex align-items-center justify-content-between bg-light"
                        style="cursor:default;">
                        @if (row.VehicleTypeName) { <span class="fw-semibold">{{ row.VehicleTypeName }}</span> } @else {
                        <span class="text-muted">No cab type set</span> }
                        <i class="bx bx-lock-alt text-muted" style="font-size:13px;"></i>
                      </div>
                      <div class="text-muted" style="font-size:10px; margin-top:2px;">
                        Using global cab type —
                        <button type="button" class="btn btn-link p-0 border-0"
                          style="font-size:10px; text-decoration:underline;"
                          (click)="openCabTypesModal()">change</button>
                      </div>
                      } @else {
                      <div style="position:relative;">
                        <input type="text" class="form-control form-control-sm" placeholder="Search vehicle…"
                          [(ngModel)]="row.VehicleSearch" (ngModelChange)="onTransportVehicleSearch(row)"
                          (focus)="onTransportVehicleSearch(row)" (blur)="onTransportVehicleBlur(row)"
                          autocomplete="off" [disabled]="!row.IteneraryServiceId">
                        @if(row.VehicleSearch.length > 0) {
                        <button type="button" class="btn btn-sm p-0 border-0 bg-transparent"
                          style="position:absolute; top:50%; right:8px; transform:translateY(-50%); font-size:14px; z-index:10; color:#999;"
                          (mousedown)="clearTransportVehicleRow(row)">×</button>
                        }
                        @if (row.ShowVehicleDropdown && row.FilteredVehicles.length > 0) {
                        <div class="border rounded bg-white shadow-sm"
                          style="position:absolute; top:100%; left:0; right:0; z-index:1000; max-height:200px; overflow-y:auto;">
                          @for (vt of row.FilteredVehicles; track vt.VehicleTypeId) {
                          <div class="px-3 py-2" style="font-size:13px; cursor:pointer;"
                            (mousedown)="selectTransportVehicleRow(row, vt)">{{ vt.VehicleTypeName }}</div>
                          }
                        </div>
                        }
                      </div>
                      @if (!row.IteneraryServiceId) {
                      <div class="text-muted" style="font-size:10px; margin-top:2px;">Select service first</div>
                      }
                      }
                      @if (!sameCabForAll) {
                      <div class="d-flex justify-content-end align-items-center gap-2 mt-2">
                        <label class="form-label small text-muted mb-0">Qty</label>
                        <input type="number" class="form-control form-control-sm text-end" style="width:70px;"
                          [(ngModel)]="row.Qty"
                          (ngModelChange)="markDirty(); recalculateTransportPrice(row); dayGroups.update(g=>[...g])"
                          min="1">
                      </div>
                      }
                    </div>
                  </div>
                </div>

                <!-- Price panel -->
                <div class="col-sm-4">
                  <div class="border rounded p-3 bg-light h-100">
                    <div class="d-flex align-items-center justify-content-between fw-semibold small mb-3">
                      <div class="d-flex align-items-center gap-2">
                        <span>Prices</span>
                        @if (row.IsSaving) { <span class="text-muted" style="font-size:11px;"><i
                            class="bx bx-loader-alt bx-spin"></i> Saving…</span> }
                      </div>
                      <button mat-icon-button (click)="EditTransportPrices(row)" matTooltip="Edit prices">
                        <mat-icon style="font-size:14px;">edit</mat-icon>
                      </button>
                    </div>
                    <table class="table table-sm mb-2" style="font-size:12px;">
                      <thead>
                        <tr class="text-muted">
                          <th>Day</th>
                          <th>Date</th>
                          <th class="text-end">Rate</th>
                          <th class="text-end">Qty</th>
                          <th class="text-end">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (day of row.DayNumbers; track day) {
                        @let daySlot = daySlots()[day - 1];
                        <tr>
                          <td class="fw-semibold text-primary">Day {{ day }}</td>
                          <td class="text-muted small">{{ daySlot?.DateLabel || '' }}</td>
                          <td class="text-end">{{ formatCurrency(row.CostPrice) }}</td>
                          <td class="text-end">{{ row.Qty }}</td>
                          <td class="text-end fw-semibold">{{ formatCurrency(row.CostPrice * row.Qty) }}</td>
                        </tr>
                        }
                      </tbody>
                      <tfoot>
                        <tr class="border-top">
                          <td colspan="4" class="fw-bold">Total</td>
                          <td class="text-end fw-bold text-primary">INR {{ formatCurrency(row.TotalPrice) }}</td>
                        </tr>
                      </tfoot>
                    </table>
                    @if (row.CostPrice > 0) {
                    <div class="mt-2">
                      <label class="form-label small text-muted mb-1">Final Price (INR) <span
                          class="text-danger">*</span></label>
                      <input type="number" class="form-control form-control-sm" [(ngModel)]="row.SellingPrice"
                        (ngModelChange)="markDirty(); recalculateTransportPrice(row)" (blur)="saveTransportRow(row)">
                      <div class="text-muted" style="font-size:10px;">Cost: INR {{ formatCurrency(row.TotalPrice) }}
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            }

            <!-- Activity rows belonging to THIS group only -->
            @for (row of group.ActivityRows; track row.RowId) {
            <div class="border rounded mb-3 p-3 bg-white">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <div class="d-flex align-items-center gap-2 text-primary fw-semibold" style="font-size:13px;"><i
                    class="bx bx-receipt"></i> Activity/Ticket</div>
                <button mat-icon-button color="warn" (click)="removeActivityRowFromGroup(group, row)"
                  matTooltip="Remove">
                  <mat-icon style="font-size:16px;">close</mat-icon>
                </button>
              </div>

              <div class="row g-3">
                <div class="col-sm-7">
                  <label class="form-label small text-muted mb-1">Name</label>
                  <div style="position:relative;">
                    <input type="text" class="form-control form-control-sm" placeholder="Search location…"
                      [(ngModel)]="row.LocationSearch" (ngModelChange)="onActivityLocationSearch(row)"
                      (focus)="onActivityLocationSearch(row)" (blur)="onActivityLocationBlur(row)" autocomplete="off">
                    @if (row.LocationSearch.length > 0) {
                    <button type="button" class="btn btn-sm p-0 border-0 bg-transparent"
                      style="position:absolute; top:50%; right:8px; transform:translateY(-50%); font-size:14px; z-index:10; color:#999;"
                      (mousedown)="clearActivityLocation(row)">×</button>
                    }
                    @if (row.ShowLocationDropdown && row.FilteredLocations.length > 0) {
                    <div class="border rounded bg-white shadow-sm"
                      style="position:absolute; top:100%; left:0; right:0; z-index:1000; max-height:180px; overflow-y:auto;">
                      @for (loc of row.FilteredLocations; track loc.LocationId) {
                      <div class="px-3 py-2" style="font-size:13px; cursor:pointer;"
                        (mousedown)="selectActivityLocation(row, loc)">{{ loc.LocationName }}</div>
                      }
                    </div>
                    }
                  </div>
                  <label class="form-label small text-muted mb-1 mt-3">Ticket/Package Type</label>
                  <div style="position:relative;">
                    <input type="text" class="form-control form-control-sm" placeholder="Search ticket/package…"
                      [(ngModel)]="row.TicketTypeSearch" (ngModelChange)="onActivityTypeSearch(row)"
                      (focus)="onActivityTypeSearch(row)" (blur)="onActivityTypeBlur(row)" autocomplete="off"
                      [disabled]="!row.LocationId">
                    @if (row.TicketTypeSearch.length > 0) {
                    <button type="button" class="btn btn-sm p-0 border-0 bg-transparent"
                      style="position:absolute; top:50%; right:8px; transform:translateY(-50%); font-size:14px; z-index:10; color:#999;"
                      (mousedown)="clearActivityType(row)">×</button>
                    }
                    @if (row.ShowTicketTypeDropdown && row.FilteredActivityServices.length > 0) {
                    <div class="border rounded bg-white shadow-sm"
                      style="position:absolute; top:100%; left:0; right:0; z-index:1000; max-height:180px; overflow-y:auto;">
                      @for (svc of row.FilteredActivityServices; track svc.ActivityServiceId) {
                      <div class="px-3 py-2" style="font-size:13px; cursor:pointer;"
                        (mousedown)="selectActivityType(row, svc, group)">{{ svc.ActivityServiceName }}</div>
                      }
                    </div>
                    }
                  </div>
                  @if (!row.LocationId) { <div class="text-muted" style="font-size:10px; margin-top:2px;">Select
                    name/location first</div> }
                </div>

                <div class="col-sm-5">
                  <div class="fw-semibold small mb-2">Tickets and Prices</div>
                  <table class="table table-sm mb-0" style="font-size:12px;">
                    <thead>
                      <tr class="text-muted">
                        <th style="width:110px;">
                          Type
                          <button mat-icon-button
                            style="width:20px; height:20px; line-height:20px; vertical-align:middle;"
                            (click)="addTypeGroup(row)" matTooltip="Add type"
                            [disabled]="!row.ActivityServiceId"><mat-icon
                              style="font-size:14px;">add</mat-icon></button>
                        </th>
                        <th style="width:50px;">Qty.</th>
                        <th>Date</th>
                        <th class="text-end">Rate</th>
                        <th class="text-end">Given</th>
                        <th style="width:20px;"></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (typeGroup of row.TypeGroups; track typeGroup.GroupId) {
                      @for (entry of typeGroup.Entries; track entry.DayNumber; let gi = $index) {
                      <tr>
                        <td>
                          @if (gi === 0) {
                          <div style="position:relative;">
                            <input type="text" class="form-control form-control-sm" placeholder="Type to search…"
                              [(ngModel)]="typeGroup.TypeSearch" (focus)="onTypeSearch(typeGroup)"
                              (blur)="onTypeBlur(typeGroup)" autocomplete="off">
                            @if (typeGroup.ShowTypeDropdown) {
                            <div class="border rounded bg-white shadow-sm"
                              style="position:absolute; top:100%; left:0; right:0; z-index:1000;">
                              @for (opt of PAX_TYPE_OPTIONS; track opt.value) {
                              <label class="px-2 py-1 mb-0 d-flex align-items-center gap-2"
                                style="font-size:12px; cursor:pointer;"
                                (mousedown)="selectPaxType(row, typeGroup, opt.value, opt.label)">
                                <input type="radio" [checked]="typeGroup.PaxType === opt.value"
                                  style="cursor:pointer;"><span>{{ opt.label }}</span>
                              </label>
                              }
                            </div>
                            }
                          </div>
                          }
                        </td>
                        <td>@if (gi === 0) { <input type="number" class="form-control form-control-sm"
                            style="width:55px;" [(ngModel)]="typeGroup.Qty"
                            (ngModelChange)="onGroupQtyChange(row, typeGroup)" min="1"> }</td>
                        <td class="text-muted">{{ formatDayDate(entry.ServiceDate) }}</td>
                        <td class="text-end"><span class="text-muted">INR</span> @if (entry.Rate > 0) { {{
                          formatCurrency(entry.Rate) }} } @else { <span class="text-warning">N/A</span> }</td>
                        <td class="text-end" style="width:75px;"><input type="number"
                            class="form-control form-control-sm text-end" [(ngModel)]="entry.GivenPrice"
                            (ngModelChange)="onActivityEntryChange(row)"
                            (blur)="saveActivityEntry(row, typeGroup, entry)" min="0"></td>
                        <td class="text-end">@if (gi === 0) { <button type="button"
                            class="btn btn-link p-0 border-0 text-danger" style="font-size:14px;"
                            (click)="removeTypeGroup(row, typeGroup)">×</button> }</td>
                      </tr>
                      }
                      }
                    </tbody>
                  </table>
                  @if (row.TypeGroups.length > 0) {
                  <div class="d-flex justify-content-end mt-2">
                    <span class="badge bg-light text-dark border" style="font-size:11px;">Total: INR {{
                      formatCurrency(getActivityRowTotal(row)) }}</span>
                  </div>
                  }
                </div>
              </div>
            </div>
            }

            <!-- Per-group Add buttons (Req. 4) -->
            <div class="d-flex gap-2 flex-wrap">
              <button class="btn btn-outline-primary btn-sm" style="font-size:12px;"
                (click)="addTransportRowToGroup(group)">
                <i class="bx bx-plus me-1"></i> Add Transport
              </button>
              <button class="btn btn-outline-success btn-sm" style="font-size:12px;"
                (click)="addActivityRowToGroup(group)">
                <i class="bx bx-plus me-1"></i> Add Activity / Ticket
              </button>
              <button class="btn btn-outline-secondary btn-sm ms-auto" style="font-size:12px;" (click)="addDayGroup()">
                <i class="bx bx-chevron-right me-1"></i> Next Day
              </button>
            </div>
          </div>
          }

          @if (getActiveDayGroups().length === 0) {
          <button class="btn btn-outline-primary btn-sm" style="font-size:12px;" (click)="addDayGroup()">
            <i class="bx bx-plus me-1"></i> Add Services
          </button>
          }


          <!-- Transport and Activities total -->
          <div class="d-flex justify-content-end gap-2 mt-2 flex-wrap">
            <div class="badge bg-info text-white px-3 py-2" style="font-size:13px;">
              Transport: INR {{ formatCurrency(transportTotal()) }}
            </div>
            <div class="badge bg-success text-white px-3 py-2" style="font-size:13px;">
              Activities: INR {{ formatCurrency(activityTotal()) }}
            </div>
            <div class="badge bg-warning text-dark px-3 py-2" style="font-size:13px; font-weight:bold;">
              Total: INR {{ formatCurrency(transportTotal() + activityTotal()) }}
            </div>
          </div>

        </div>
      </div>

      <!-- ════════════════════════════════════════════════════════ -->
      <!-- EDIT TRANSPORT PRICES MODAL                             -->
      <!-- ════════════════════════════════════════════════════════ -->
      @if (showEditTransportPricesModal && editingTransportRow) {
      <div class="modal-backdrop fade show" style="z-index:1060; backdrop-filter:blur(3px);"></div>
      <div class="modal fade show d-block" style="z-index:1070;" tabindex="-1">
        <div class="modal-dialog modal-md modal-dialog-centered">
          <div class="modal-content border-0 shadow-lg">

            <div class="modal-header border-bottom px-4 py-3">
              <div>
                <h5 class="modal-title fw-bold mb-0" style="font-size:15px;">
                  Edit Transport Prices
                </h5>
                <div class="text-muted" style="font-size:12px;">
                  {{ editingTransportRow.VehicleTypeName }} •
                  {{ editingTransportRow.IteneraryServiceName }}
                </div>
              </div>
              <button type="button" class="btn-close" (click)="closeEditTransportPricesModal()"></button>
            </div>

            <div class="modal-body px-4 py-3">
              <table class="table table-sm table-bordered" style="font-size:13px;">
                <thead class="table-light">
                  <tr>
                    <th>Type</th>
                    <th class="text-end">System Rate</th>
                    <th class="text-end">Qty</th>
                    <th class="text-end">Given Rate</th>
                    <th class="text-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="align-middle">
                      Transport
                      <div class="text-muted" style="font-size:10px;">per unit</div>
                    </td>
                    <td class="text-end align-middle text-muted">
                      {{ formatCurrency(editingTransportRow.CostPrice) }}
                    </td>
                    <td class="align-middle" style="width:60px;">
                      <input type="number" class="form-control form-control-sm text-end"
                        [(ngModel)]="editingTransportRow.Qty" (ngModelChange)="recalculateEditTransportPrice()" min="1"
                        style="width:60px;">
                    </td>
                    <td class="align-middle" style="width:110px;">
                      <input type="number" class="form-control form-control-sm text-end"
                        [(ngModel)]="editTransportPrices.VehicleRate" (ngModelChange)="recalculateEditTransportPrice()"
                        min="0" style="width:110px;">
                    </td>
                    <td class="text-end align-middle fw-semibold">
                      {{ formatCurrency(editTransportPrices.VehicleRate * editingTransportRow.Qty *
                      editingTransportRow.DayNumbers.length) }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="table-light">
                    <td colspan="4" class="fw-bold">Cost Total</td>
                    <td class="text-end fw-bold">
                      INR {{ formatCurrency(editTransportPrices.ComputedTotal) }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="modal-footer border-top">
              <button class="btn btn-outline-secondary btn-sm px-3"
                (click)="closeEditTransportPricesModal()">Cancel</button>
              <button class="btn btn-primary btn-sm px-4" (click)="applyEditTransportPrices()">
                Apply
              </button>
            </div>

          </div>
        </div>
      </div>
      }

      <!-- ════════════════════════════════════════════════════════ -->
      <!-- SELECT CAB TYPES MODAL                                    -->
      <!-- ════════════════════════════════════════════════════════ -->
      @if (showCabTypesModal) {
      <div class="modal-backdrop fade show" style="z-index:1090; backdrop-filter:blur(3px);"
        (click)="closeCabTypesModal()"></div>
      <div class="modal fade show d-block" style="z-index:1100;" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content border-0 shadow-lg">
            <div class="modal-header border-bottom px-4 py-3">
              <h5 class="modal-title fw-bold" style="font-size:15px;">
                Select Cab Types
              </h5>
              <button type="button" class="btn-close" (click)="closeCabTypesModal()"></button>
            </div>
            <div class="modal-body px-4 py-3">
              <table class="table table-sm" style="font-size:13px;">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th class="text-end">Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  @for (cabType of cabTypesList; track $index; let i = $index) {
                  <tr>
                    <td>
                      <select class="form-select form-select-sm" [(ngModel)]="cabType.VehicleTypeId"
                        (ngModelChange)="onCabTypeSelected(cabType)">
                        <option [value]="0">Select vehicle…</option>
                        @for (vt of vehicleTypeList(); track vt.VehicleTypeId) {
                        <option [value]="vt.VehicleTypeId">{{ vt.VehicleTypeName }}</option>
                        }
                      </select>
                    </td>
                    <td class="text-end" style="width:100px;">
                      <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="cabType.Quantity"
                        min="1">
                    </td>
                    <td class="text-end" style="width:30px;">
                      <button type="button" class="btn btn-link p-0 border-0 text-danger" style="font-size:16px;"
                        (click)="removeCabType(i)">
                        ×
                      </button>
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
              <button type="button" class="btn btn-link btn-sm p-0 text-primary"
                style="font-size:12px; text-decoration:none;" (click)="addCabType()">
                <i class="bx bx-plus me-1"></i> Add More
              </button>
            </div>
            <div class="modal-footer border-top px-4 py-3">
              <button type="button" class="btn btn-outline-secondary btn-sm px-3"
                (click)="closeCabTypesModal()">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm px-4" (click)="saveCabTypes()">Set Cab Types</button>
            </div>
          </div>
        </div>
      </div>
      }

      <!-- ════════════════════════════════════════════════════════════ -->
      <!-- SUMMARY SECTION - Redesigned                               -->
      <!-- ════════════════════════════════════════════════════════════ -->
      <div class="card border-0 shadow-sm mb-4">
        <div class="card-body p-4">

          <!-- Header -->
          <div class="fw-bold fs-5 mb-1">Summary</div>
          <div class="text-muted small mb-4">
            Please review the quote's data before creating.
          </div>

          <!-- ════════════════════════════════════════════════════════ -->
          <!-- BASIC INFO ROW                                          -->
          <!-- ════════════════════════════════════════════════════════ -->
          <div class="row g-3 mb-4 pb-3 border-bottom">
            <div class="col-md-3">
              <div class="text-muted small text-uppercase fw-semibold" style="font-size:10px; letter-spacing:0.5px;">
                Start Date
              </div>
              <div class="fw-bold">{{ trip.StartDate | date:'dd MMM, yyyy' }}</div>
            </div>
            <div class="col-md-3">
              <div class="text-muted small text-uppercase fw-semibold" style="font-size:10px; letter-spacing:0.5px;">
                Duration
              </div>
              <div class="fw-bold">
                {{ trip.NoOfNights }} Night{{ trip.NoOfNights > 1 ? 's' : '' }},
                {{ trip.NoOfNights + 1 }} Days
              </div>
            </div>
            <div class="col-md-3">
              <div class="text-muted small text-uppercase fw-semibold" style="font-size:10px; letter-spacing:0.5px;">
                PAX
              </div>
              <div class="fw-bold">{{ paxLabel }}</div>
            </div>
            <div class="col-md-3 text-md-end">
              <span class="badge bg-primary bg-opacity-10 text-primary px-3 py-2">
                <i class="bx bx-calendar me-1"></i> Quote #{{ formatQuotationNo(trip.QuotationNo) }}
              </span>
            </div>
          </div>

<!-- ═══════════════════════════════════════════════════ -->
<!-- SUMMARY — ACCOMMODATION PER PACKAGE                  -->
<!-- ═══════════════════════════════════════════════════ -->
<div class="card border-0 shadow-sm mb-4">
  <div class="card-body p-0">

    @for (pkg of packageTypes(); track pkg.QuotePackageTypeId; let pi = $index) {
      @if (getHotelsByPackage(pkg.QuotePackageTypeId).length > 0) {

      <!-- ── Package Option Header ── -->
      <div class="px-4 pt-4 pb-2">
        <h6 class="fw-bold mb-0" style="color:#1a73e8; font-size:14px;">
          Option {{ pi + 1 }}: {{ pkg.PackageTypeName }}
        </h6>
      </div>

      <!-- ── Accommodation ── -->
      @if (getHotelsByPackage(pkg.QuotePackageTypeId).length > 0) {
        <div class="px-4 pb-2">

          <div class="d-flex align-items-center gap-2 mb-2">
            <div class="bg-primary rounded-circle d-flex align-items-center
                        justify-content-center text-white flex-shrink-0"
                 style="width:28px; height:28px; font-size:12px;">
              <i class="bx bx-hotel"></i>
            </div>
            <span class="fw-semibold" style="font-size:13.5px;">Accommodation</span>
          </div>

          <table class="table table-sm mb-0" style="font-size:13px;">
            <thead>
              <tr style="border-bottom:1px solid #e0e0e0;">
                <th class="text-muted fw-normal py-2"
                    style="font-size:12px; width:120px;">Night</th>
                <th class="text-muted fw-normal py-2"
                    style="font-size:12px;">Hotel</th>
                <th class="text-muted fw-normal py-2"
                    style="font-size:12px; width:100px;">Meal</th>
                <th class="text-muted fw-normal py-2"
                    style="font-size:12px; width:200px;">Rooms</th>
                <th class="text-muted fw-normal py-2 text-end"
                    style="font-size:12px; width:120px;">Price / Night</th>
              </tr>
            </thead>
            <tbody>
              @for (group of getGroupedHotelsByPackage(pkg.QuotePackageTypeId);
                    track group.hotel.QuoteHotelId) {
                @let h = group.hotel;
                @let effective = getEffectiveHotel(h);
                @for (nightNum of group.nightNumbers; track nightNum) {
                  @let nightSlot = nightSlots().find(s => s.NightNumber === nightNum);
                  <tr style="border-bottom:1px solid #f5f5f5;">
                    <td class="py-2">
                      <div class="fw-medium">
                        {{ nightNum }}{{ getNightOrdinal(nightNum) }}
                      </div>
                      <div class="text-muted" style="font-size:11px;">
                        {{ nightSlot?.StayDate | date:'d MMM' }}
                      </div>
                    </td>
                    <td class="py-2">
                      <div class="fw-medium">{{ h.HotelName }}</div>
                      <div class="text-muted d-flex align-items-center gap-1"
                           style="font-size:11px;">
                        {{ effective.LocationName }},
                        {{ effective.HotelCategoryName }}
                      </div>
                      @for (sim of h.SimilarHotels; track sim.QuoteHotelId) {
                        <div class="text-muted" style="font-size:11px;">
                          / <span class="fw-medium">{{ sim.HotelName }}</span>
                          @if (sim.HotelCategoryName) { {{ sim.HotelCategoryName }} }
                          <br>
                          {{ sim.NoOfRooms }} {{ sim.RoomTypeName }}
                          ({{ sim.PaxPerRoom }}A
                          @if (sim.AWEB) { · {{ sim.AWEB }} AwEB }
                          @if (sim.CNB) { · {{ sim.CNB }} CNB }
                          )
                        </div>
                      }
                    </td>
                    <td class="py-2">{{ effective.MealPlan }}</td>
                    <td class="py-2">
                      <div>{{ effective.NoOfRooms }} {{ effective.RoomTypeName }}</div>
                      <div class="text-muted" style="font-size:11px;">
                        {{ effective.PaxPerRoom }} Pax
                      </div>
                    </td>
                   <td class="py-2 text-end">
    @let summaryPrice = getAccommodationSummaryPrice(h, group.nightNumbers.length);
    @if (summaryPrice > 0) {
        <span class="text-success me-1">✓</span>
    }
    <span class="text-muted" style="font-size:10px;">INR</span>
    <span class="fw-medium">
        {{ formatCurrency(summaryPrice) }}
    </span>
    @if (effective.AWEB > 0 || effective.CWEB > 0 || effective.CNB > 0) {
        <div class="text-muted" style="font-size:9px;">
            @if (effective.AWEB > 0) { +{{ effective.AWEB }} AwEB }
            @if (effective.CWEB > 0) { +{{ effective.CWEB }} CWEB }
            @if (effective.CNB > 0) { +{{ effective.CNB }} CNB }
        </div>
    }
</td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      }

      <!-- ── Hotel Special Inclusions ── -->
      @if (getSpecialInclusionsByPackage(pkg.QuotePackageTypeId).length > 0) {
        <div class="px-4 pb-2 mt-2">

          <div class="fw-semibold mb-2" style="font-size:13px;">
            Hotel Special Inclusions
          </div>

          <table class="table table-sm mb-0" style="font-size:13px;">
            <thead>
              <tr style="border-bottom:1px solid #e0e0e0;">
                <th class="text-muted fw-normal py-2"
                    style="font-size:12px; width:120px;">Night</th>
                <th class="text-muted fw-normal py-2"
                    style="font-size:12px;">Hotel</th>
                <th class="text-muted fw-normal py-2"
                    style="font-size:12px; width:200px;">Service</th>
                <th class="text-muted fw-normal py-2 text-end"
                    style="font-size:12px; width:120px;">Price</th>
              </tr>
            </thead>
            <tbody>
              @for (si of getSpecialInclusionsByPackage(pkg.QuotePackageTypeId);
                    track si.QuoteSpecialInclusionId) {
                <tr style="border-bottom:1px solid #f5f5f5;">
                  <td class="py-2">
                    <div class="fw-medium">
                      {{ si.NightNumbers?.[0] }}{{ getNightOrdinal(si.NightNumbers?.[0] || 0) }}
                    </div>
                    <div class="text-muted" style="font-size:11px;">
                      {{ getNightDate(si.NightNumbers?.[0] || 0) }}
                    </div>
                  </td>
                  <td class="py-2">
                    <div class="fw-medium">
                      {{ si.HotelName || si.ManualLocationName }}
                    </div>
                    <div class="text-muted" style="font-size:11px;">
                      {{ si.LocationName }}
                      @if (si.HotelCategoryName) {
                        , {{ si.HotelCategoryName }}
                      }
                    </div>
                  </td>
                  <td class="py-2">{{ si.SpecialInclusionName }}</td>
                  <td class="py-2 text-end">
                    <span class="text-muted" style="font-size:10px;">INR</span>
                    <span class="fw-medium">
                      {{ formatCurrency(si.TotalPrice) }}
                    </span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      <!-- ── Per-package total ── -->
      <div class="px-4 py-3 d-flex justify-content-end"
           style="border-top:1px solid #f0f0f0; margin-top:8px;">
        <span class="text-muted small me-3">Total:</span>
        <span class="text-muted" style="font-size:10px; margin-top:2px;">INR</span>
        <span class="fw-bold ms-1" style="font-size:15px;">
          {{ formatCurrency(getPackageAccommodationTotal(pkg.QuotePackageTypeId)) }}
        </span>
      </div>

      <!-- Divider between packages -->
      @if (pi < packageTypes().length - 1) {
        <hr class="mx-4 my-0">
      }

      }
    }

  </div>
</div>

          <!-- ════════════════════════════════════════════════════════ -->
          <!-- TRANSPORTATION & ACTIVITIES SECTION                    -->
          <!-- ════════════════════════════════════════════════════════ -->
          @if (hasAnyTransportOrActivity()) {
          <div class="mb-4">
            <div class="d-flex align-items-center gap-2 mb-3">
              <div class="bg-primary rounded-circle d-flex align-items-center justify-content-center text-white"
                style="width:32px; height:32px; font-size:14px;">
                <i class="bx bx-car"></i>
              </div>
              <span class="fw-bold fs-6">Transportation and Activities</span>
            </div>

            @for (slot of daySlots(); track slot.DayNumber) {
            @let dayItems = getDayItems(slot.DayNumber);
            @if (dayItems.length > 0) {

            <div class="d-flex mb-3" style="gap:0;">

              <!-- LEFT: Day label box -->
              <div class="flex-shrink-0 d-flex flex-column align-items-start justify-content-start px-3 py-3" style="width:100px; background:#f0f4ff; border:0.5px solid #dee2e6;
                      border-right:none; border-radius:8px 0 0 8px;">
                <div class="fw-bold" style="font-size:13px;">
                  {{ getDayOrdinalLabel(slot.DayNumber) }}
                </div>
                <div class="text-muted" style="font-size:11px; margin-top:2px;">
                  {{ slot.DateLabel.slice(0,2) }}, {{ slot.DateLabel.slice(3) }}
                </div>
              </div>

              <!-- RIGHT: Service rows container -->
              <div class="flex-grow-1 border bg-white" style="border-radius:0 8px 8px 0; overflow:hidden;">

                @for (item of dayItems; track item.id; let last = $last) {
                <div class="d-flex align-items-center px-3 py-2"
                  [style.border-bottom]="last ? 'none' : '0.5px solid #f0f0f0'">

                  <!-- Col 1: Location + Service name (40%) -->
                  <div style="flex:0 0 40%; min-width:0;">
                    <div class="fw-semibold text-truncate" style="font-size:13px;">
                      {{ item.location }}
                    </div>
                    <div class="text-muted d-flex align-items-center gap-1" style="font-size:11px; margin-top:2px;">
                      <span>{{ item.serviceName }}</span>
                      @if (item.detail && (item.id.startsWith('t') || item.id.startsWith('s'))) {
                      <span>· {{ item.detail }}</span>
                      }
                      <i class="bx bx-transfer-alt" style="font-size:12px; color:#aaa;"></i>
                    </div>
                  </div>

                  <!-- Col 2: Vehicle / Pax type + breakdown (30%) -->
                  <div style="flex:0 0 30%; min-width:0; padding-left:12px;">
                    @if (item.id.startsWith('t') || item.id.startsWith('s')) {
                    <!-- Transport: vehicle name in blue, breakdown below -->
                    <div class="fw-medium" style="font-size:13px;">
                      {{ item.detail }}
                      @if (item.quantity && item.quantity > 1) {
                      <span class="text-muted" style="font-size:11px;"> × {{ item.quantity }}</span>
                      }
                    </div>
                    @if (item.breakdown) {
                    <div style="font-size:11px; color:#0d6efd;">
                      {{ item.breakdown }}
                    </div>
                    } @else if (item.price > 0) {
                    <div style="font-size:11px; color:#0d6efd;">
                      {{ formatCurrency(item.price) }}
                    </div>
                    }
                    } @else {
                    <!-- Activity: pax type label + breakdown -->
                    <div class="fw-medium" style="font-size:13px;">
                      {{ item.quantity }} {{ item.detail }}
                    </div>
                    @if (item.breakdown) {
                    <div style="font-size:11px; color:#0d6efd;">
                      {{ item.breakdown }}
                    </div>
                    }
                    }
                  </div>

                  <!-- Col 3: Spacer -->
                  <div style="flex:1;"></div>

                  <!-- Col 4: Price (right aligned) -->
                  <div class="text-end" style="flex:0 0 auto; min-width:100px;">
                    @if (item.price > 0) {
                    <div class="d-flex align-items-center justify-content-end gap-1">
                      <i class="bx bx-check" style="font-size:14px; color:#198754;"></i>
                      <span class="text-muted" style="font-size:10px;">INR</span>
                      <span class="fw-bold" style="font-size:13px;">
                        {{ formatCurrency(item.price) }}
                      </span>
                    </div>
                    } @else {
                    <span class="text-muted" style="font-size:12px;">—</span>
                    }
                  </div>

                </div>
                }

              </div>
            </div>

            }
            }

            @if (packageTypes().length > 0) {
            <!-- Main container aligned to the right -->
            <div class="d-flex flex-wrap justify-content-end align-items-start gap-3 mt-3">

              <div class="d-flex flex-row gap-3 mt-3">

                @for (pkg of packageTypes(); track pkg.QuotePackageTypeId; let index = $index) {
                @let overviewSummary = getDisplayPackageSummary(pkg.QuotePackageTypeId, pkg.PackageTypeName);
                <div class="border rounded-3 p-3 bg-white shadow-sm" style="border:1px solid #d2d8f7 !important;">

                  <!-- Package Heading -->
                  <div class="mb-3">
                    <span class="fw-semibold text-dark" style="font-size:13px; border-bottom:2px solid #dee2e6;">
                      Option {{ index + 1 }}: {{ pkg.PackageTypeName }}
                    </span>
                  </div>

                  <!-- Content -->
                  <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">

                    <!-- Total Cost -->
                    <div class="rounded px-3 py-2 text-center"
                      style="background:#f4f6fc; border:1px solid #d2d8f7; min-width:140px;">
                      <div class="fw-semibold text-primary mb-1" style="font-size:12px;">Total Cost</div>
                      <div class="fw-bold text-dark" style="font-size:16px;">
                        <span class="text-secondary fw-normal" style="font-size:10px;">INR</span>
                        {{ formatCurrency(overviewSummary.CostPrice) }}
                      </div>
                    </div>

                    <!-- Hotels + Activities -->
                    <div class="d-flex align-items-center justify-content-end flex-grow-1 gap-4">

                      <!-- Hotels -->
                      <div class="text-end">
                        <div class="fw-semibold mb-1" style="font-size:12px;">Hotels</div>
                        <div class="fw-bold" style="font-size:14px;">
                          <span class="text-secondary fw-normal" style="font-size:10px;">INR</span>
                          {{ formatCurrency((overviewSummary.HotelTotal || 0) + (overviewSummary.SpecialInclusionTotal || 0)) }}
                        </div>
                        <div class="text-muted small" style="font-size:10px;">(includes special inclusions)</div>
                      </div>

                      <div class="fw-bold" style="font-size:18px;">+</div>

                      <!-- Activities -->
                      <div class="text-end">
                        <div class="fw-semibold mb-1" style="font-size:12px;">Activities/Tickets</div>
                        <div class="fw-bold" style="font-size:14px;">
                          <span class="text-secondary fw-normal" style="font-size:10px;">INR</span>
                          {{ formatCurrency(overviewSummary.TransportTotal + overviewSummary.ActivityTotal) }}
                        </div>
                      </div>

                    </div>

                  </div>

                </div>
                }


              </div>

            </div>
            <!-- Footer -->
            <div class="text-end text-muted" style="font-size:12px;">
              It is the total cost price for all the provided services. This is NOT the selling price.
            </div>

            } @else {
            <div class="d-flex justify-content-end mt-3">
              <div class="border rounded px-3 py-2 text-end bg-white" style="min-width:240px;">
                <div class="fw-bold" style="font-size:13px;">
                  Total:
                  <span class="text-primary ms-1">INR {{ formatCurrency(transportTotal() + activityTotal()) }}</span>
                </div>
                <div class="text-muted mt-1" style="font-size:11px;">
                  Transport: <span class="fw-semibold text-dark ms-1">INR {{ formatCurrency(transportTotal()) }}</span>
                  <span class="mx-2">•</span>
                  Activity/Tickets: <span class="fw-semibold text-dark ms-1">INR {{ formatCurrency(activityTotal())
                    }}</span>
                </div>
              </div>
            </div>
            }

          </div>
          }


<!-- ════════════════════════════════════════════════════════ -->
<!-- PRICING STRATEGY - UNIFIED GLOBAL + PER-PACKAGE        -->
<!-- ════════════════════════════════════════════════════════ -->
<div class="mb-4">

  <!-- ── Global Top Controls ── -->
  <div class="d-flex align-items-center gap-3 flex-wrap mb-4 p-3 border rounded"
    style="background:#f8f9fa;">
    <div>
      <label class="form-label small fw-semibold mb-1">Pricing Strategy</label>
      <select class="form-select form-select-sm" style="width:160px;"
        [(ngModel)]="pricingStrategy" (ngModelChange)="onPricingStrategyChange()">
        <option value="per-person">Per-Person</option>
        <option value="overall">Overall</option>
      </select>
    </div>
    <div>
      <label class="form-label small fw-semibold mb-1">Selling Currency</label>
      <select class="form-select form-select-sm" style="width:100px;"
        [(ngModel)]="sellingCurrency">
        <option value="INR">INR</option>
        <option value="USD">USD</option>
        <option value="EUR">EUR</option>
      </select>
    </div>
    @if (pricingStrategy === 'overall') {
    <div>
      <label class="form-label small fw-semibold mb-1">
        Total FOC
        <!-- <span class="badge bg-warning text-dark ms-1" style="font-size:10px;">NEW</span> -->
        <!-- <i class="bx bx-info-circle ms-1 text-muted" style="font-size:13px;"></i> -->
      </label>
      <input type="number" class="form-control form-control-sm" style="width:90px;"
        [(ngModel)]="totalFOC" (ngModelChange)="onFOCChange()" min="0"
        [max]="totalGuestCount() - 1">
    </div>
    }
  </div>

  <!-- ── Per-Package Blocks ── -->
  @for (pkg of packageTypes(); track pkg.QuotePackageTypeId; let pkgIdx = $index) {

  <!-- Package Banner -->
  <div class="d-flex align-items-center justify-content-between px-4 py-1 mb-0"
    style="background:#1a1a2e; color:#fff; border-radius:6px 6px 3px 3px;">
    <span class="fw-bold" style="font-size:15px;">{{ pkg.PackageTypeName }}</span>
    <span class="text-muted" style="font-size:13px;">Option {{ pkgIdx + 1 }}</span>
  </div>

  <!-- Package Content -->
  <div class="border border-top-0 rounded-bottom p-4 mb-4 bg-white">

    <div class="row g-4">
    <!-- ── PER-PERSON MODE ── -->
    @if (pricingStrategy === 'per-person') {
<div class="col-lg-4">
    <!-- Per-Person Settings header -->
    <div class="text-primary fw-semibold mb-2" style="font-size:13px;">
      Per-Person Settings
    </div>

    <!-- Pax info -->
    <div class="text-muted small mb-3">
      [{{ totalAdults() }} Adult{{ totalAdults() > 1 ? 's' : '' }}
      @if (childrenCount > 0) { + {{ childrenCount }} Child{{ childrenCount > 1 ? 'ren' : '' }} }]
    </div>

    <!-- Transport Inclusions -->
    <div class="mb-3">
      <div class="text-muted small fw-semibold mb-2">Transports Inclusions</div>
      <div class="d-flex align-items-center gap-2 mb-2">
        <input type="checkbox" [(ngModel)]="excludeTransportCharges"
          (ngModelChange)="markDirty()" id="excTransport_{{ pkg.QuotePackageTypeId }}" style="cursor:pointer;">
        <label [for]="'excTransport_' + pkg.QuotePackageTypeId" class="small mb-0" style="cursor:pointer;">
          Exc. Transport charges for
        </label>
        <input type="number" class="form-control form-control-sm text-center" style="width:55px;"
          [(ngModel)]="excludeTransportCount" (ngModelChange)="markDirty()" min="0" [max]="totalAdults()">
        <span class="small">Adults</span>
      </div>
      <div class="d-flex align-items-center gap-2 mb-2">
        <input type="checkbox" [(ngModel)]="incAwebInTransports"
          (ngModelChange)="markDirty()" id="incAweb_{{ pkg.QuotePackageTypeId }}" style="cursor:pointer;">
        <label [for]="'incAweb_' + pkg.QuotePackageTypeId" class="small mb-0" style="cursor:pointer;">
          Inc. AwEB in Transports
        </label>
      </div>
      <div class="d-flex align-items-center gap-2 mb-2">
        <input type="checkbox" [(ngModel)]="incChildInTransports"
          (ngModelChange)="markDirty()" id="incChild_{{ pkg.QuotePackageTypeId }}" style="cursor:pointer;">
        <label [for]="'incChild_' + pkg.QuotePackageTypeId" class="small mb-0" style="cursor:pointer;">
          Inc. Child:
        </label>
        <input type="number" class="form-control form-control-sm text-center" style="width:55px;"
          [(ngModel)]="incChildTransportAge" (ngModelChange)="markDirty()" min="0" max="17">
        <span class="small">yrs and onwards</span>
      </div>
      <div class="text-muted small fst-italic">
        {{ getTransportChargeableSummary(pkg.QuotePackageTypeId) }}
      </div>
    </div>
</div>

    <div class="col-lg-8">
    <!-- Per-Person breakdown mini table -->
    <div class="border rounded mb-4" style="overflow:hidden;">
      <table class="table table-sm mb-0" style="font-size:13px;">
        <thead class="table-light">
          <tr>
            <th style="width:40%;">For</th>
            <th class="text-end" style="width:30%;">Price (INR)</th>
            <th class="text-end" style="width:30%;">Segregation</th>
          </tr>
        </thead>
        <tbody>
          @for (row of getDisplayPricingRows(pkg.QuotePackageTypeId); track row.key) {
          <tr>
            <td>
              <div class="fw-medium">{{ getPricingRowDisplay(row) }}</div>
            </td>
            <td class="text-end fw-semibold">
              {{ formatMoney(row.costPrice) }}
            </td>
            <td class="text-end text-muted" style="font-size:12px;">
              @for (component of row.breakdown; track component.label) {
              @if (!$first) { <span class="mx-1">|</span> }
              <span>{{ component.label }}: {{ formatMoney(component.amount) }}</span>
              }
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    </div>
    }
</div>
    <!-- ── SET MARKUP, TAX AND ROUNDING ── -->
<!-- Set Markup, Tax and Rounding Section -->
<div class="mb-4">
  <h6 class="mb-3 text-primary">Set Markup, Tax and Rounding</h6>
  
  <div class="table-responsive">
    <table class="table table-sm table-bordered" style="font-size:15px;">
      <thead class="table-light">
        <tr>
          <th style="width:250px;">For</th>
          <th style="width:120px;">Cost Price (INR)</th>
          <th style="width:120px;">
            <div>Markup</div>
            <select class="form-select form-select-sm mt-1"
              [(ngModel)]="markupType" (ngModelChange)="markDirty()"
              style="font-size:10px; padding:1px 3px;">
              <option value="percentage">Percentage</option>
              <option value="fixed">Fixed Amount</option>
            </select>
          </th>
          <th style="width:150px;">
            <div>Tax Applied On</div>
            <select class="form-select form-select-sm mt-1"
              [(ngModel)]="taxAppliedOn" (ngModelChange)="markDirty()"
              style="font-size:10px; padding:1px 3px;">
              <option value="cost">Cost Only</option>
              <option value="markup">Markup Only</option>
              <option value="cost-markup">Cost + Markup</option>
            </select>
          </th>
          <th class="text-end" style="width:16%; border:1px solid #dee2e6;">
              <div class="d-flex align-items-center justify-content-end gap-1 flex-wrap">
                <input type="checkbox" [(ngModel)]="gstEnabled"
                  (ngModelChange)="markDirty()" style="cursor:pointer;"
                  id="gst_{{ pkg.QuotePackageTypeId }}">
                <label [for]="'gst_' + pkg.QuotePackageTypeId"
                  style="cursor:pointer; margin:0; font-weight:normal;">GST</label>
                @if (gstEnabled) {
                <input type="number" class="form-control form-control-sm text-end d-inline-block"
                  [(ngModel)]="gstPercent" (ngModelChange)="markDirty()"
                  style="width:45px; padding:2px 4px;" min="0" max="28">
                <span style="font-size:11px;">%</span>
                }
              </div>
            </th>

          <th style="width:100px;">Total (INR)</th>
           <th class="text-center" style="width:6%; border:1px solid #dee2e6;">
              <div class="d-flex align-items-center justify-content-center gap-1">
                <span style="font-size:11px;">Round</span>
                <select class="form-select form-select-sm d-inline-block"
                  [(ngModel)]="roundingMode" (ngModelChange)="markDirty()"
                  style="width:45px; font-size:10px; padding:1px 3px;">
                  <option value="none">-</option>
                  <option value="1">1</option>
                  <option value="10">10</option>
                  <option value="100">100</option>
                </select>
              </div>
            </th>

        </tr>
      </thead>
      <tbody>
        <!-- Per-Person Strategy -->
        @if (pricingStrategy === 'per-person') {
          <!-- Per-Person row -->
          @for (row of getDisplayPricingRows(pkg.QuotePackageTypeId); track row.key) {
          <tr>
            <td class="fw-semibold">{{ row.tableLabel }}<br><span class="text-muted small">{{ getPricingRowSubText(row) }}</span></td>
            <td class="text-end fw-bold">
              {{ formatMoney(row.costPrice) }}
              <div class="text-muted" style="font-size:10px;">× {{ row.qty }} = {{ formatMoney(row.costPrice * row.qty) }}</div>
            </td>

            <!-- MARKUP COLUMN - Per-Person EDIT MODE -->
            <td class="text-end">
              <div class="d-flex align-items-center justify-content-end gap-2">
                @if (markupEditMode[pkg.QuotePackageTypeId] === 'person') {
                  <!-- Edit Mode -->
                  <input type="number" 
                    class="form-control form-control-sm text-end"
                    [value]="row.markupInput"
                    (change)="onPricingRowMarkupChange(row.key, +$event.target.value)"
                    style="width:70px; padding:2px 4px;"
                    min="0"
                    autofocus>
                  <button class="btn btn-sm btn-link p-0 text-success" 
                    (click)="toggleMarkupEdit(pkg.QuotePackageTypeId, 'person')">
                    <mat-icon style="font-size:14px; width:14px; height:14px;">check_circle</mat-icon>
                  </button>
                } @else {
                  <!-- View Mode -->
                  <span class="fw-semibold">{{ formatMoney(row.markupInput) }}</span>
                  <button class="btn btn-sm btn-link p-0 text-muted" 
                    (click)="toggleMarkupEdit(pkg.QuotePackageTypeId, 'person')"
                    matTooltip="Edit per-person markup">
                    <mat-icon style="font-size:14px; width:14px; height:14px;">edit</mat-icon>
                  </button>
                }
              </div>
              <div class="text-muted" style="font-size:10px;">
                = {{ formatMoney(row.markupAmount * row.qty) }}
              </div>
            </td>

            <td class="text-end fw-semibold text-muted" style="font-size:12px;">{{ getTaxAppliedOnLabel() }}</td>
            <td class="text-end fw-bold">
              {{ formatMoney(row.gstAmount) }}
              <div class="text-muted" style="font-size:10px;">{{ gstPercent }}%</div>
            </td>
            <td class="text-end fw-bold" style="color:#1a73e8;">
              {{ formatMoney(row.totalBeforeRounding) }}
              <div class="text-muted" style="font-size:10px;">INR</div>
            </td>
            <td class="text-end fw-bold">
              @if (roundingMode !== 'none') {
                {{ formatMoney(row.roundedTotal) }}
                <div class="text-muted" style="font-size:10px;">× {{ row.qty }}</div>
              }
            </td>
          </tr>
          }

          <!-- Total row (Per-Person) -->
          <tr style="background:#fffbec;">
            <td class="fw-bold">Total</td>
            <td class="text-end fw-bold">
              {{ formatMoney(getPackagePricingCostTotal(pkg.QuotePackageTypeId)) }}
            </td>

            <!-- MARKUP COLUMN - Total EDIT MODE -->
            <td class="text-end">
              <div class="d-flex align-items-center justify-content-end gap-2">
                @if (markupEditMode[pkg.QuotePackageTypeId] === 'total') {
                  <!-- Edit Mode -->
                  <input type="number" 
                    class="form-control form-control-sm text-end"
                    [value]="getTotalMarkup(pkg.QuotePackageTypeId)"
                    (change)="onTotalMarkupChange(pkg.QuotePackageTypeId, +$event.target.value)"
                    style="width:70px; padding:2px 4px;"
                    min="0"
                    autofocus>
                  <button class="btn btn-sm btn-link p-0 text-success" 
                    (click)="toggleMarkupEdit(pkg.QuotePackageTypeId, 'total')">
                    <mat-icon style="font-size:14px; width:14px; height:14px;">check_circle</mat-icon>
                  </button>
                } @else {
                  <!-- View Mode -->
                  <span class="fw-semibold">{{ formatMoney(getPackagePricingMarkupTotal(pkg.QuotePackageTypeId)) }}</span>
                  <button class="btn btn-sm btn-link p-0 text-muted" 
                    (click)="toggleMarkupEdit(pkg.QuotePackageTypeId, 'total')"
                    matTooltip="Edit total markup">
                    <mat-icon style="font-size:14px; width:14px; height:14px;">edit</mat-icon>
                  </button>
                }
              </div>
              <div class="text-muted" style="font-size:10px;">
                = {{ formatMoney(getPackagePricingMarkupTotal(pkg.QuotePackageTypeId)) }}
              </div>
            </td>

            <td class="text-end fw-semibold text-muted" style="font-size:12px;">{{ getTaxAppliedOnLabel() }}</td>
            <td class="text-end fw-bold">
              {{ formatMoney(getPackagePricingGstTotal(pkg.QuotePackageTypeId)) }}
              <div class="text-muted" style="font-size:10px;">{{ gstPercent }}%</div>
            </td>
            <td class="text-end fw-bold" style="color:#1a73e8;">
              {{ formatMoney(getPackagePricingFinalTotal(pkg.QuotePackageTypeId)) }}
              <div class="text-muted" style="font-size:10px;">INR</div>
            </td>
            <td class="text-end fw-bold">
              @if (roundingMode !== 'none') {
                {{ formatMoney(getPackagePricingRoundedTotal(pkg.QuotePackageTypeId)) }}
                <div class="text-muted" style="font-size:10px;">INR</div>
              } @else {
                <span class="text-muted">—</span>
              }
            </td>
          </tr>
        }

        <!-- Overall Strategy -->
        @if (pricingStrategy === 'overall') {
          <!-- Total row (Overall) -->
          <tr style="background:#fffbec;">
            <td class="fw-bold">Total</td>
            <td class="text-end fw-bold">
              {{ formatMoney(getPackageTotalCost(pkg.QuotePackageTypeId)) }}
            </td>

            <!-- MARKUP COLUMN - Total EDIT MODE (Overall) -->
            <td class="text-end">
              <div class="d-flex align-items-center justify-content-end gap-2">
                @if (markupEditMode[pkg.QuotePackageTypeId] === 'total') {
                  <!-- Edit Mode -->
                  <input type="number" 
                    class="form-control form-control-sm text-end"
                    [value]="getTotalMarkup(pkg.QuotePackageTypeId)"
                    (change)="onTotalMarkupChange(pkg.QuotePackageTypeId, +$event.target.value)"
                    style="width:70px; padding:2px 4px;"
                    min="0"
                    autofocus>
                  <button class="btn btn-sm btn-link p-0 text-success" 
                    (click)="toggleMarkupEdit(pkg.QuotePackageTypeId, 'total')">
                    <mat-icon style="font-size:14px; width:14px; height:14px;">check_circle</mat-icon>
                  </button>
                } @else {
                  <!-- View Mode -->
                  <span class="fw-semibold">{{ formatMoney(getTotalMarkup(pkg.QuotePackageTypeId)) }}</span>
                  <button class="btn btn-sm btn-link p-0 text-muted" 
                    (click)="toggleMarkupEdit(pkg.QuotePackageTypeId, 'total')"
                    matTooltip="Edit total markup">
                    <mat-icon style="font-size:14px; width:14px; height:14px;">edit</mat-icon>
                  </button>
                }
              </div>
              <div class="text-muted" style="font-size:10px;">
                = {{ formatMoney(getPackageMarkupAmount(pkg.QuotePackageTypeId)) }}
              </div>
            </td>

            <td class="text-end fw-semibold text-muted" style="font-size:12px;">{{ getTaxAppliedOnLabel() }}</td>
            <td class="text-end fw-bold">
              {{ formatMoney(getPackageGstAmount(pkg.QuotePackageTypeId)) }}
              <div class="text-muted" style="font-size:10px;">{{ gstPercent }}%</div>
            </td>
            <td class="text-end fw-bold" style="color:#1a73e8;">
              {{ formatMoney(getPackageFinalPrice(pkg.QuotePackageTypeId)) }}
              <div class="text-muted" style="font-size:10px;">INR</div>
            </td>
            <td class="text-end fw-bold">
              @if (roundingMode !== 'none') {
                {{ formatMoney(getPackageRoundedPrice(pkg.QuotePackageTypeId)) }}
                <div class="text-muted" style="font-size:10px;">INR</div>
              } @else {
                <span class="text-muted">—</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

    <!-- Per-guest summary line (both modes) -->
    @if (payingGuestCount() > 0 && pricingStrategy === 'per-person') {
    <div class="text-muted mt-2" style="font-size:12px;">
      Final price per paying guest:
      <span class="fw-bold text-dark ms-1">
        INR {{ formatMoney(getPackagePerPayingGuestPrice(pkg.QuotePackageTypeId)) }}
      </span>
      <span class="mx-2">×</span>
      <span>{{ payingGuestCount() }} guests =</span>
      <span class="fw-bold text-dark ms-1">
        INR {{ formatMoney(getDisplayPackageSummary(pkg.QuotePackageTypeId, pkg.PackageTypeName).GrandTotal) }}
      </span>
    </div>
    }

    <!-- ── Internal Notes + Remarks (side by side) ── -->
    <div class="row g-3 mt-3">
      <div class="col-md-6">
        <div class="text-muted small mb-1">
          Any internal comments regarding selling price
          <span class="text-muted" style="font-size:11px;">(optional)</span>
        </div>
        <textarea class="form-control form-control-sm" rows="3"
          [(ngModel)]="internalNotes" (ngModelChange)="markDirty()"
          placeholder="Internal notes..."></textarea>
      </div>
      <div class="col-md-6">
        <div class="d-flex align-items-center gap-3 mb-1">
          <span class="text-muted small">
            Remarks for Agent/Customer
            <span style="font-size:11px;">(optional)</span>
          </span>
          <div class="btn-group btn-group-sm">
            <button class="btn btn-outline-primary btn-sm py-0"
              [class.active]="remarksTab === 'write'"
              (click)="remarksTab = 'write'">Write</button>
            <button class="btn btn-outline-primary btn-sm py-0"
              [class.active]="remarksTab === 'preview'"
              (click)="remarksTab = 'preview'">Preview</button>
          </div>
        </div>
        @if (remarksTab === 'write') {
        <div class="border rounded" style="background:#fff;">
          <quill-editor [(ngModel)]="customerRemarks" (ngModelChange)="markDirty()"
            [modules]="quillModules"
            placeholder="Any special remarks for the customer..."
            style="min-height:80px; display:block; border:none;"></quill-editor>
        </div>
        <div class="text-muted small mt-1">These remarks will be shared with the customer.</div>
        } @else {
        <div class="border rounded p-3" style="min-height:80px; background:#fff; font-size:13px;">
          <div [innerHTML]="getSanitizedRemarks() || 'No remarks added yet.'"></div>
        </div>
        <div class="text-muted small mt-1">These remarks will be shared with the customer.</div>
        }
      </div>
    </div>

  </div>
  <!-- END package content -->
  }
  <!-- END package loop -->

</div>
       <!-- ════════════════════════════════════════════════════════ -->
<!-- FINAL PACKAGE PREVIEW                                   -->
<!-- ════════════════════════════════════════════════════════ -->
<div class="border rounded p-4" style="background:linear-gradient(135deg,#e8f4ff,#f0f8ff);">

  <!-- Header -->
  <div class="d-flex align-items-center gap-3 mb-4">
    <div class="bg-primary rounded-circle d-flex align-items-center justify-content-center text-white flex-shrink-0"
      style="width:42px; height:42px; font-size:18px;">
      <i class="bx bx-receipt"></i>
    </div>
    <div>
      <div class="fw-bold fs-5 mb-0">Preview Final Package Price</div>
      <div class="text-muted small">Here are the final prices for this quote.</div>
    </div>
  </div>

  <!-- One row per package -->
  @for (pkg of packageTypes(); track pkg.QuotePackageTypeId; let pi = $index) {

  @let displaySummary = getDisplayPackageSummary(pkg.QuotePackageTypeId, pkg.PackageTypeName);
  @let displayPrice = displaySummary.GrandTotal;

  <div class="d-flex align-items-stretch gap-0 mb-3"
    style="border:1px solid #dee2e6; border-radius:6px; overflow:hidden;">

    <!-- ── Dark label box (left) ── -->
    <div class="flex-shrink-0 px-3 py-3 d-flex flex-column justify-content-center"
      style="background:#1a1a2e; color:#fff; min-width:260px; max-width:280px;">
      <div style="font-size:11px; color:#aaa; letter-spacing:0.4px;">
        Option {{ pi + 1 }}
      </div>
      <div class="fw-bold mt-1" style="font-size:15px;">
        {{ pkg.PackageTypeName }}
      </div>
    </div>

    <!-- ── Right side ── -->
    <div class="flex-grow-1 bg-white">

      <!-- ═══ PER-PERSON MODE: mini table ═══ -->
      @if (pricingStrategy === 'per-person') {
      <table class="table table-sm mb-0 h-100" style="font-size:13px;">
        <thead>
          <tr style="border-bottom:1px solid #dee2e6;">
            <!-- empty left column aligns with label below -->
            <th class="fw-normal text-muted" style="width:40%; border:none; padding:10px 16px;"></th>
            <th class="fw-semibold text-end" style="width:20%; border:none; padding:10px 12px;">Per Pax</th>
            <th class="fw-semibold text-end" style="width:15%; border:none; padding:10px 12px; color:#1a73e8;">Qnty.</th>
            <th class="fw-semibold text-end" style="width:25%; border:none; padding:10px 16px;">Sub Total</th>
          </tr>
        </thead>
        <tbody>
          <!-- Data rows — sourced from the same getPackagePricingRows() the
               calculation table uses, so Preview can never drift out of sync. -->
          @for (row of getDisplayPricingRows(pkg.QuotePackageTypeId); track row.key) {
          <tr style="border-bottom:1px solid #dee2e6;">
            <td class="text-muted" style="padding:10px 16px; border:none;">
              {{ getPricingRowDisplay(row) }}
            </td>
            <td class="text-end" style="padding:10px 12px; border:none;">
              {{ formatCurrency(row.roundedTotal) }}
            </td>
            <td class="text-end fw-semibold" style="padding:10px 12px; border:none; color:#1a73e8;">
              {{ row.qty }}
            </td>
            <td class="text-end" style="padding:10px 16px; border:none;">
              {{ formatCurrency(row.roundedTotal * row.qty) }}
            </td>
          </tr>
          }
          <!-- Total row -->
          <tr>
            <td style="padding:10px 16px; border:none;"></td>
            <td colspan="2" class="text-end" style="padding:10px 12px; border:none;">
              <div class="fw-bold" style="font-size:14px;">Total</div>
              <div class="text-muted" style="font-size:11px;">
                Tax: GST
                @if (gstEnabled) { (Included {{ gstPercent }}%) }
                @else { (Excluded) }
              </div>
            </td>
            <td class="text-end" style="padding:10px 16px; border:none; vertical-align:middle;">
              <div class="d-flex align-items-baseline justify-content-end gap-1">
                <span class="text-muted" style="font-size:12px;">INR</span>
                <span class="fw-bold" style="font-size:20px;">
                  {{ formatCurrency(displayPrice) }}
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      }

      <!-- ═══ OVERALL MODE: detailed breakdown with FOC ═══ -->
      @if (pricingStrategy === 'overall') {
      <div class="d-flex flex-column justify-content-center h-100 px-4 py-3">
        <div class="d-flex align-items-baseline gap-1 mb-2">
          <span class="text-muted" style="font-size:14px;">INR</span>
          <span style="font-size:36px; font-weight:700; letter-spacing:-1px;">
            {{ formatCurrency(displayPrice) }}
          </span>
        </div>
        <div style="font-size:13px; color:#666; margin-bottom:8px;">
          {{ formatCurrency(getPerPaxPrice(displayPrice)) }} /- Per Person X {{ payingGuestCount() }} Pax
          @if (totalFOC && totalFOC > 0) {
          + {{ totalFOC }} FOC
          }
        </div>
        <div class="text-muted" style="font-size:13px;">
          @if (gstEnabled) {
          GST: Included ({{ gstPercent }}%)
          } @else {
          GST: Not Applied
          }
        </div>
      </div>
      }

    </div>
    <!-- end right side -->

  </div>
  <!-- end package row -->
  }

  <!-- Save / Cancel -->
  <div class="d-flex gap-3 pt-3 mt-2">
    <button mat-raised-button color="primary" style="min-width:130px;"
      (click)="saveQuote()" [disabled]="loading()">
      <i class="bx bx-save me-1"></i>
      {{ loading() ? 'Saving…' : (QuoteId > 0 ? 'Update Quote' : 'Save Quote') }}
    </button>
    <button mat-stroked-button (click)="cancel()">Cancel</button>
  </div>

</div>

      </div>
    </div>


  </div>
}




<!-- ════════════════════════════════════════════════════════ -->
<!-- PACKAGE TYPES MODAL                                      -->
<!-- ════════════════════════════════════════════════════════ -->
@if (showPkgModal) {
<div class="modal-backdrop fade show" style="z-index:1040; backdrop-filter:blur(3px);" (click)="closePkgModal()">
</div>

<div class="modal fade show d-block" style="z-index:1050;" tabindex="-1">
  <div class="modal-dialog  modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg">

      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold" style="font-size:15px;">
          Package Types/Options
        </h5>
        <button type="button" class="btn-close" (click)="closePkgModal()"></button>
      </div>

      <div class="modal-body px-4 py-3">
        <table class="table table-sm mb-3" style="font-size:13px;">
          <thead>
            <tr>
              <th style="width:30px;">#</th>
              <th>Name</th>
              <th style="width:30px;"></th>
            </tr>
          </thead>
          <tbody>
            @for (row of pkgModalRows; track $index; let i = $index) {
            <tr>
              <td class="text-muted">{{ i + 1 }}</td>
              <td>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="row.PackageTypeName"
                  (ngModelChange)="markDirty()" placeholder="e.g. Deluxe Package">
              </td>
              <td>
                <button mat-icon-button style="width:24px;height:24px;line-height:24px;" (click)="removePkgRow(i)">
                  <mat-icon style="font-size:14px;">close</mat-icon>
                </button>
              </td>
            </tr>
            }
          </tbody>
        </table>
        <button class="btn btn-link btn-sm p-0 text-primary" style="font-size:13px; text-decoration:none;"
          (click)="addPkgRow()">
          <i class="bx bx-plus me-1"></i> Add More
        </button>
      </div>

      <div class="modal-footer border-top px-4 py-3">
        <button class="btn btn-primary btn-sm px-4" (click)="savePkgTypes()">Save</button>
        <button class="btn btn-outline-secondary btn-sm px-3" (click)="closePkgModal()">Cancel</button>
      </div>

    </div>
  </div>
</div>
}




<!--Modal create new hotel -->
@if (showNewHotelModal) {
<div class="modal-backdrop fade show" style="z-index:1060; backdrop-filter:blur(3px);"></div>
<div class="modal fade show d-block" style="z-index:1070;" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg">

      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold" style="font-size:15px;">
          <i class="bx bx-hotel me-2"></i> Add New Hotel
        </h5>
        <button type="button" class="btn-close" (click)="closeNewHotelModal()"></button>
      </div>

      <div class="modal-body px-4 py-3">

        <!-- Hotel Details -->
        <div class="row g-3 mb-4">
          <div class="col-sm-4">
            <label class="form-label small fw-semibold">Location <span class="text-danger">*</span></label>
            <div style="position:relative;">
              <input type="text" class="form-control form-control-sm" placeholder="Search location..."
                [(ngModel)]="locationSearchText" (ngModelChange)="onLocationSearch()" (focus)="onLocationSearch()"
                (blur)="onLocationBlur()" autocomplete="off">

              <!-- Clear button -->
              @if (locationSearchText.length > 0) {
              <button type="button" class="btn btn-sm p-0 border-0 bg-transparent" style="
                            position:absolute;
                            top:50%;
                            right:8px;
                            transform:translateY(-50%);
                            font-size:14px;
                            line-height:1;
                            z-index:10;
                            color:#999;
                          "(mousedown)="clearLocation()">
                ×
              </button>
              }

              @if (showLocationDropdown && filteredLocations.length > 0) {
              <div class="border rounded bg-white shadow-sm" style="position:absolute; top:100%; left:0; right:0;
                              z-index:1000; max-height:180px; overflow-y:auto;">
                <!-- Location dropdown items -->
                @for (l of filteredLocations; track l.LocationId) {
                <div class="px-3 py-2" style="font-size:13px; cursor:pointer;"
                  (mousedown)="$event.preventDefault(); selectLocation(l)">
                  {{ l.LocationName }}
                </div>
                }
              </div>
              }

              @if (showLocationDropdown && locationSearchText.length > 0
              && filteredLocations.length === 0) {
              <div class="border rounded bg-white shadow-sm px-3 py-2 text-muted" style="position:absolute; top:100%; left:0; right:0;
                              z-index:1000; font-size:13px;">
                No locations found
              </div>
              }
            </div>
          </div>
          <div class="col-sm-3">
            <label class="form-label small fw-semibold">Category <span class="text-danger">*</span></label>
            <select class="form-select form-select-sm" [(ngModel)]="newHotel.HotelCategoryId">
              <option [value]="0">Select category…</option>
              @for (c of hotelCategoryList(); track c.HotelCategoryId) {
              <option [value]="c.HotelCategoryId">{{ c.HotelCategoryName }}</option>
              }
            </select>
          </div>
          <div class="col-sm-4">
            <label class="form-label small fw-semibold">Hotel Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="newHotel.HotelName"
              placeholder="Enter hotel name">
          </div>
        </div>

        <!-- Room Types -->
        <div class="mb-2 d-flex align-items-center justify-content-between">
          <div class="fw-semibold small">Room Types</div>
          <button class="btn btn-outline-primary btn-sm" style="font-size:12px;" (click)="addNewRoomTypeRow()">
            <i class="bx bx-plus me-1"></i> Add Room Type
          </button>
        </div>

        <table class="table table-sm table-bordered" style="font-size:13px;">
          <thead class="table-light">
            <tr>
              <th style="width:30px;">#</th>
              <th>Room Type Name</th>
              <th style="width:40px;"></th>
            </tr>
          </thead>
          <tbody>
            @for (rt of newRoomTypes; track $index; let i = $index) {
            <tr>
              <td class="text-muted align-middle">{{ i + 1 }}</td>
              <td>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="rt.RoomTypeName"
                  placeholder="e.g. Deluxe Room">
              </td>
              <td class="text-center align-middle">
                <button mat-icon-button color="warn" style="width:24px;height:24px;line-height:24px;"
                  (click)="removeNewRoomTypeRow(i)">
                  <mat-icon style="font-size:14px;">close</mat-icon>
                </button>
              </td>
            </tr>
            }
            @if (newRoomTypes.length === 0) {
            <tr>
              <td colspan="3" class="text-center text-muted py-3" style="font-size:12px;">
                No room types added yet. Click "Add Room Type" to add.
              </td>
            </tr>
            }
          </tbody>
        </table>

      </div>

      <div class="modal-footer border-top px-4 py-3">
        @if (newHotelSaving) {
        <span class="text-muted small me-3">
          <i class="bx bx-loader-alt bx-spin"></i> Saving…
        </span>
        }
        <button class="btn btn-outline-secondary btn-sm px-3" (click)="closeNewHotelModal()">Cancel</button>
        <button class="btn btn-primary btn-sm px-4" (click)="saveNewHotel()" [disabled]="newHotelSaving">
          Save Hotel
        </button>
      </div>

    </div>
  </div>
</div>
}
<!-- Edit Prices Modal -->
@if (showEditPricesModal && editingHotelRow) {
<div class="modal-backdrop fade show" style="z-index:1060; backdrop-filter:blur(3px);"></div>
<div class="modal fade show d-block" style="z-index:1070;" tabindex="-1">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg">

      <div class="modal-header border-bottom px-4 py-3">
        <div>
          <h5 class="modal-title fw-bold mb-0" style="font-size:15px;">
            Edit Prices
          </h5>
          <div class="text-muted" style="font-size:12px;">
            {{ editingHotelRow.HotelName }} •
            {{ editingHotelRow.MealPlan }} •
            {{ editingHotelRow.RoomTypeName }}
          </div>
        </div>
        <button type="button" class="btn-close" (click)="closeEditPricesModal()"></button>
      </div>

      <div class="modal-body px-4 py-3">

        <table class="table table-sm table-bordered" style="font-size:13px;">
          <thead class="table-light">
            <tr>
              <th>Type</th>
              <th class="text-end">System Rate</th>
              <th class="text-end">Qty</th>
              <th class="text-end">Given Rate</th>
              <th class="text-end">Total</th>
            </tr>
          </thead>
          <tbody>

            <!-- Rooms -->
            <tr>
              <td class="align-middle">
                Rooms
                <div class="text-muted" style="font-size:10px;">per room/night</div>
              </td>
              <td class="text-end align-middle text-muted">
                {{ formatCurrency(editingHotelRow.BaseRate) }}
              </td>
              <td class="align-middle" style="width:60px;">
                <input type="number" class="form-control form-control-sm text-end"
                  [(ngModel)]="editingHotelRow.NoOfRooms" (ngModelChange)="recalculateEditPrice()" min="1"
                  style="width:60px;">
              </td>
              <td class="align-middle" style="width:110px;">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editPrices.RoomRate"
                  (ngModelChange)="recalculateEditPrice()" min="0" style="width:110px;">
              </td>
              <td class="text-end align-middle fw-semibold">
                {{ formatCurrency(editPrices.RoomRate * editingHotelRow.NoOfRooms) }}
              </td>
            </tr>

            <!-- AWEB -->
            <tr>
              <td class="align-middle">
                AWEB
              </td>
              <td class="text-end align-middle text-muted">
                {{ formatCurrency(editingHotelRow.AwebRate) }}
              </td>
              <td class="align-middle">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editingHotelRow.AWEB"
                  (ngModelChange)="recalculateEditPrice()" min="0" style="width:60px;">
              </td>
              <td class="align-middle">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editPrices.AwebRate"
                  (ngModelChange)="recalculateEditPrice()" min="0" style="width:110px;">
              </td>
              <td class="text-end align-middle fw-semibold">
                {{ formatCurrency(editPrices.AwebRate * editingHotelRow.AWEB) }}
              </td>
            </tr>

            <!-- CWEB -->
            <tr>
              <td class="align-middle">
                CWEB
              </td>
              <td class="text-end align-middle text-muted">
                {{ formatCurrency(editingHotelRow.CwebRate) }}
              </td>
              <td class="align-middle">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editingHotelRow.CWEB"
                  (ngModelChange)="recalculateEditPrice()" min="0" style="width:60px;">
              </td>
              <td class="align-middle">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editPrices.CwebRate"
                  (ngModelChange)="recalculateEditPrice()" min="0" style="width:110px;">
              </td>
              <td class="text-end align-middle fw-semibold">
                {{ formatCurrency(editPrices.CwebRate * editingHotelRow.CWEB) }}
              </td>
            </tr>

            <!-- CNB -->
            <tr>
              <td class="align-middle">
                CNB
              </td>
              <td class="text-end align-middle text-muted">
                {{ formatCurrency(editingHotelRow.CnbRate) }}
              </td>
              <td class="align-middle">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editingHotelRow.CNB"
                  (ngModelChange)="recalculateEditPrice()" min="0" style="width:60px;">
              </td>
              <td class="align-middle">
                <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="editPrices.CnbRate"
                  (ngModelChange)="recalculateEditPrice()" min="0" style="width:110px;">
              </td>
              <td class="text-end align-middle fw-semibold">
                {{ formatCurrency(editPrices.CnbRate * editingHotelRow.CNB) }}
              </td>
            </tr>

          </tbody>
          <tfoot>
            <tr class="table-light">
              <td colspan="4" class="fw-bold">Cost Total</td>
              <td class="text-end fw-bold">
                INR {{ formatCurrency(editPrices.ComputedTotal) }}
              </td>
            </tr>
          </tfoot>
        </table>


      </div>

      <div class="modal-footer border-top  ">
        <button class="btn btn-outline-secondary btn-sm px-3" (click)="closeEditPricesModal()">Cancel</button>
        <button class="btn btn-primary btn-sm px-4" (click)="applyEditPrices()">
          Apply
        </button>
      </div>

    </div>
  </div>
</div>
}
<app-unsaved-changes-dialog></app-unsaved-changes-dialog>